var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUiImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2271.17 1371.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#bdd0fb;}.cls-3{fill:#91b3fa;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:#7d97f4;}.cls-6{opacity:0.85;}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#linear-gradient-8);}.cls-13{fill:url(#linear-gradient-9);}.cls-14{fill:url(#linear-gradient-10);}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:url(#linear-gradient-12);}.cls-17{fill:url(#linear-gradient-13);}.cls-18{fill:url(#linear-gradient-14);}.cls-19{fill:url(#linear-gradient-15);}.cls-20,.cls-37,.cls-93{fill:#fff;}.cls-20{opacity:0.62;}.cls-21{fill:url(#linear-gradient-16);}.cls-22{fill:url(#linear-gradient-17);}.cls-23{fill:url(#linear-gradient-18);}.cls-24{fill:url(#linear-gradient-19);}.cls-25{fill:url(#linear-gradient-20);}.cls-26{fill:#18174a;}.cls-27{fill:#2b69b3;}.cls-28{fill:url(#linear-gradient-21);}.cls-29{fill:url(#linear-gradient-22);}.cls-30{fill:url(#linear-gradient-23);}.cls-31{fill:url(#linear-gradient-24);}.cls-32{fill:url(#linear-gradient-25);}.cls-33{fill:url(#linear-gradient-26);}.cls-34{fill:url(#linear-gradient-27);}.cls-35{fill:url(#linear-gradient-28);}.cls-36{fill:url(#linear-gradient-29);}.cls-38{fill:url(#linear-gradient-30);}.cls-39{fill:url(#linear-gradient-31);}.cls-40{fill:url(#linear-gradient-32);}.cls-41{fill:url(#linear-gradient-33);}.cls-42{fill:url(#linear-gradient-34);}.cls-43{fill:url(#linear-gradient-35);}.cls-44{fill:url(#linear-gradient-36);}.cls-45{fill:url(#linear-gradient-37);}.cls-46{fill:url(#linear-gradient-38);}.cls-47{fill:url(#linear-gradient-39);}.cls-48{fill:url(#linear-gradient-40);}.cls-49{fill:url(#linear-gradient-41);}.cls-50{fill:url(#linear-gradient-42);}.cls-51{fill:url(#linear-gradient-43);}.cls-52{fill:url(#linear-gradient-44);}.cls-53{fill:url(#linear-gradient-45);}.cls-54{fill:url(#linear-gradient-46);}.cls-55{fill:url(#linear-gradient-47);}.cls-56{fill:url(#linear-gradient-48);}.cls-57{fill:url(#linear-gradient-49);}.cls-58{fill:url(#linear-gradient-50);}.cls-59{fill:url(#linear-gradient-51);}.cls-60{fill:url(#linear-gradient-52);}.cls-61{fill:url(#linear-gradient-53);}.cls-62{fill:url(#linear-gradient-54);}.cls-63{fill:url(#linear-gradient-55);}.cls-64{fill:url(#linear-gradient-56);}.cls-65{fill:url(#linear-gradient-57);}.cls-66{fill:url(#linear-gradient-58);}.cls-67{fill:url(#linear-gradient-59);}.cls-68{fill:url(#linear-gradient-60);}.cls-69{fill:url(#linear-gradient-61);}.cls-70{fill:url(#linear-gradient-62);}.cls-71{fill:url(#linear-gradient-63);}.cls-72{fill:url(#linear-gradient-64);}.cls-73{fill:url(#linear-gradient-65);}.cls-74{fill:url(#linear-gradient-66);}.cls-75{fill:url(#linear-gradient-67);}.cls-76{fill:url(#linear-gradient-68);}.cls-77{fill:url(#linear-gradient-69);}.cls-78{fill:url(#linear-gradient-70);}.cls-79{fill:url(#linear-gradient-71);}.cls-80{fill:url(#linear-gradient-72);}.cls-81{fill:url(#linear-gradient-73);}.cls-82{fill:url(#linear-gradient-74);}.cls-83{fill:url(#linear-gradient-75);}.cls-84{fill:url(#linear-gradient-76);}.cls-85{fill:url(#linear-gradient-77);}.cls-86{fill:url(#linear-gradient-78);}.cls-87{fill:url(#linear-gradient-79);}.cls-88{fill:url(#linear-gradient-80);}.cls-89{fill:url(#linear-gradient-81);}.cls-90{fill:url(#linear-gradient-82);}.cls-91{fill:url(#linear-gradient-83);}.cls-92{fill:url(#linear-gradient-84);}.cls-93{opacity:0.15;}.cls-94{fill:url(#linear-gradient-85);}.cls-95{fill:url(#linear-gradient-86);}.cls-96{fill:url(#linear-gradient-87);}.cls-97{fill:url(#linear-gradient-88);}.cls-98{fill:url(#linear-gradient-89);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 6.03,
    y1: 668.33,
    x2: 2184.16,
    y2: 668.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 64.85,
    y1: 1048.34,
    x2: 600.42,
    y2: 1048.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 216.52,
    y1: 1030.25,
    x2: 407.23,
    y2: 1030.25,
    gradientTransform: "translate(819.84 81.22) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 497.2,
    y1: 967.35,
    x2: 454.49,
    y2: 1008.91,
    gradientTransform: "translate(-1.83 -34.97) rotate(0.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 484.68,
    y1: 974.05,
    x2: 429.26,
    y2: 1057.77,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 453.66,
    y1: 956.11,
    x2: 453.85,
    y2: 956.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 455.01,
    y1: 948.56,
    x2: 468.44,
    y2: 948.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 497.76,
    y1: 1052.05,
    x2: 455.05,
    y2: 1093.61,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 485.24,
    y1: 1058.74,
    x2: 429.82,
    y2: 1142.46,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 453.66,
    y1: 1040.81,
    x2: 453.85,
    y2: 1040.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 455.01,
    y1: 1033.26,
    x2: 468.44,
    y2: 1033.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 498.32,
    y1: 1136.75,
    x2: 455.61,
    y2: 1178.31,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 485.8,
    y1: 1143.44,
    x2: 430.38,
    y2: 1227.16,
    gradientTransform: "matrix(0.7, 0.71, -0.71, 0.7, 956.89, -25.51)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 453.66,
    y1: 1125.51,
    x2: 453.85,
    y2: 1125.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 455.01,
    y1: 1117.96,
    x2: 468.44,
    y2: 1117.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 519.52,
    y1: 1082.02,
    x2: 514.75,
    y2: 1094.46,
    gradientTransform: "matrix(-0.98, -0.19, -0.19, 0.98, 1393.51, 137.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a737d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef497a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1640.13,
    y1: 1120.81,
    x2: 2202.47,
    y2: 1120.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1552.7,
    y1: 1339.27,
    x2: 1547.93,
    y2: 1351.71,
    gradientTransform: "translate(-138.52 137.36) rotate(-10.96)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1791.25,
    y1: 1045.56,
    x2: 1788.11,
    y2: 1053.75,
    gradientTransform: "translate(115.22 -70.09) rotate(6.75)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1847.02,
    y1: 842.97,
    x2: 1954.58,
    y2: 842.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1916.2,
    y1: 446.08,
    x2: 1977.11,
    y2: 446.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1865.64,
    y1: 445.66,
    x2: 2026.56,
    y2: 445.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1752.28,
    y1: 273.8,
    x2: 1787.6,
    y2: 273.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1723.94,
    y1: 273.59,
    x2: 1815.28,
    y2: 273.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1121.51,
    y1: 483.51,
    x2: 893.48,
    y2: 927.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1282.06,
    y1: 565.96,
    x2: 1054.04,
    y2: 1010,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1201.03,
    y1: 524.34,
    x2: 973.01,
    y2: 968.39,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1790.72,
    y1: 934.93,
    x2: 2850.26,
    y2: -53.13,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1929.97,
    y1: 783.21,
    x2: 1695.95,
    y2: 1032.24,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 666.01,
    y1: 1233.04,
    x2: 1391.58,
    y2: 1233.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 702.01,
    y1: 1163.09,
    x2: 987.28,
    y2: 1163.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 702.01,
    y1: 1205.05,
    x2: 987.28,
    y2: 1205.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 702.01,
    y1: 1247.02,
    x2: 987.28,
    y2: 1247.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 702.01,
    y1: 1288.99,
    x2: 987.28,
    y2: 1288.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1164.53,
    y1: 762.15,
    x2: 1096.53,
    y2: 1022.15,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1270.22,
    y1: 789.79,
    x2: 1202.22,
    y2: 1049.79,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1386.29,
    y1: 820.15,
    x2: 1318.29,
    y2: 1080.15,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1009.13,
    y1: 1248.76,
    x2: 1104.85,
    y2: 1248.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1128.08,
    y1: 1248.76,
    x2: 1223.8,
    y2: 1248.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1247.02,
    y1: 1248.76,
    x2: 1342.74,
    y2: 1248.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1009.13,
    y1: 1302.43,
    x2: 1104.85,
    y2: 1302.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1128.08,
    y1: 1302.43,
    x2: 1223.8,
    y2: 1302.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1247.02,
    y1: 1302.43,
    x2: 1342.74,
    y2: 1302.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 4149.31,
    y1: 1220.59,
    x2: 4164.26,
    y2: 1220.59,
    gradientTransform: "translate(-3628.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 4095.42,
    y1: 1219.85,
    x2: 4108.33,
    y2: 1219.85,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -1798.55,
    y1: 2198.61,
    x2: -2025.51,
    y2: 2449.04,
    gradientTransform: "matrix(-1, 0, 0, 1, -130.75, 0)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -797.87,
    y1: 816.72,
    x2: -572.61,
    y2: 954.44,
    gradientTransform: "matrix(-1, 0, 0, 1, -130.75, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -800.14,
    y1: 763.6,
    x2: -774.45,
    y2: 837.01,
    gradientTransform: "matrix(-1, 0, 0, 1, -130.75, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 654.29,
    y1: 731.21,
    x2: 658.65,
    y2: 771.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -1762.11,
    y1: 2213.02,
    x2: -1987.37,
    y2: 2461.58,
    gradientTransform: "matrix(-1, 0, 0, 1, -130.75, 0)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 4043.68,
    y1: 947.28,
    x2: 4140.36,
    y2: 947.28,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 548.67,
    y1: 865.25,
    x2: 532.98,
    y2: 901.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 513.69,
    y1: 826.06,
    x2: 498.11,
    y2: 901.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 110.78,
    y1: 4399.79,
    x2: 67.41,
    y2: 4344.95,
    gradientTransform: "matrix(0.75, -0.67, 0.67, 0.75, 2092.08, -1593.36)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 106.01,
    y1: 4407.28,
    x2: 62.61,
    y2: 4352.41,
    gradientTransform: "matrix(0.75, -0.67, 0.67, 0.75, 2092.08, -1593.36)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1206.72,
    y1: 560.44,
    x2: 1236.63,
    y2: 560.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1256.69,
    y1: 580.08,
    x2: 1286.6,
    y2: 580.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1306.67,
    y1: 531.54,
    x2: 1336.57,
    y2: 531.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1356.64,
    y1: 596.91,
    x2: 1386.54,
    y2: 596.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1406.61,
    y1: 543.04,
    x2: 1436.52,
    y2: 543.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1456.58,
    y1: 555.95,
    x2: 1486.49,
    y2: 555.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 1506.55,
    y1: 569.98,
    x2: 1536.46,
    y2: 569.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1556.52,
    y1: 514.15,
    x2: 1586.43,
    y2: 514.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1606.49,
    y1: 525.09,
    x2: 1636.4,
    y2: 525.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1656.46,
    y1: 541.64,
    x2: 1686.37,
    y2: 541.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1706.44,
    y1: 598.83,
    x2: 1736.34,
    y2: 598.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1756.41,
    y1: 562.4,
    x2: 1786.31,
    y2: 562.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1013.59,
    y1: 218.65,
    x2: 250.5,
    y2: 370,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 467.5,
    y1: 319.06,
    x2: 713.49,
    y2: 167.57,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 717.3,
    y1: 78.85,
    x2: 573.31,
    y2: 222.85,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 1411.48,
    y1: 271.43,
    x2: 1442.2,
    y2: 271.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1419.7,
    y1: 253.38,
    x2: 1468.76,
    y2: 253.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1415.73,
    y1: 239.79,
    x2: 1492.39,
    y2: 239.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1411.77,
    y1: 226.21,
    x2: 1515.9,
    y2: 226.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 1775.04,
    y1: 776.46,
    x2: 1775.04,
    y2: 819.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 11379.53,
    y1: 816.25,
    x2: 11393.06,
    y2: 816.25,
    gradientTransform: "matrix(-1, 0, 0, 1, 13174.15, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 11293.53,
    y1: 804.97,
    x2: 11309.7,
    y2: 804.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 13174.15, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 6189.3,
    y1: 6980.95,
    x2: 6095.3,
    y2: 7096.95,
    gradientTransform: "matrix(-1, 0, 0, 1, 13174.15, 0)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 1869.73,
    y1: 570.54,
    x2: 1823.73,
    y2: 617.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 11367.6,
    y1: 569.3,
    x2: 11310.05,
    y2: 620.27,
    gradientTransform: "matrix(-1, 0, 0, 1, 13174.15, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 6152.76,
    y1: 6951.34,
    x2: 6058.76,
    y2: 7067.34,
    gradientTransform: "matrix(-1, 0, 0, 1, 13174.15, 0)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 6229.7,
    y1: 7013.68,
    x2: 6135.7,
    y2: 7129.68,
    gradientTransform: "matrix(-1, 0, 0, 1, 13174.15, 0)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 11475.49,
    y1: 574.12,
    x2: 11520.82,
    y2: 574.12,
    gradientTransform: "matrix(-1, 0, 0, 1, 13174.15, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 11431.43,
    y1: 453,
    x2: 11430.94,
    y2: 537.64,
    gradientTransform: "matrix(-1, 0, 0, 1, 13174.15, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 11390.33,
    y1: 594.97,
    x2: 11332.77,
    y2: 645.94,
    gradientTransform: "matrix(-1, 0, 0, 1, 13174.15, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 1686.31,
    y1: 526.92,
    x2: 1669.81,
    y2: 546.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 7275.95,
    y1: 4606.3,
    x2: 7296.45,
    y2: 4559.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 10841.15, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 7264.68,
    y1: 4601.32,
    x2: 7285.18,
    y2: 4554.82,
    gradientTransform: "matrix(-1, 0, 0, 1, 10841.15, 0)",
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 1262.72,
    y1: 290.43,
    x2: 1327.15,
    y2: 290.43,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1076.23,1330s-739.57,8.27-945.57-177.85S2.2,780.44,159.93,727.88s184.64-107.23,99.76-181S67,321.81,246,169.7s383.2,66.37,543.17,37.36,96.61-126.72,307-59.24,164-129,333.11-146.8S1581,205.37,1755,121.51s316.24-72.28,391,60.89,42.3,312.56-121.77,419.46-146.46,99.61-85.15,204.65,116.31,450.48-162.84,499.82S1076.23,1330,1076.23,1330Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M622.23,1254.11a4.71,4.71,0,0,0-3.57-7.47c-41.66-1.46-215.78-16.69-209-169.37,7.68-173.36,20.45-222.69-60.87-281.82-74-53.84-139.06-46.56-189.67-21.67a3.77,3.77,0,0,0,1.65,7.14c33.86-.26,111.45,5.41,140.13,60.2,37.15,70.94,34,247.47,109.86,330.47,75,82,139,79.49,207.5,84.39a4.53,4.53,0,0,0,4-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63,675a7.71,7.71,0,0,1,1.65-12.78c13.69-6.53,38.23-21.38,62.4-51.7s85.7-94.8,183.16-57.59S409,773.8,397.57,952.32,571.91,1230,571.91,1230l49.2,30.11s-182.37-64.59-230.47-208.55S389.72,706.92,274,689.39C162.85,672.55,135.7,736.08,63,675Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.81,870.62c-6.12,1.27-10.28-6-6.15-10.81,23.67-27.42,75.88-76.38,138.2-63.32,85.43,17.9,141.48,68.4,198.43,222.59C393.65,1169,568,1249.19,617.17,1259.39a4.83,4.83,0,0,1,3.82,4.91h0a4.86,4.86,0,0,1-5.9,4.67c-34.41-8-214.79-52.39-298-118C229.73,1082.13,126,846.07,7.81,870.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.76,837.43c14.93-3.72,30.29-4.33,45.51-3.1,3.81.24,7.58.81,11.37,1.3,3.76.66,7.54,1.23,11.26,2.13a167.31,167.31,0,0,1,22,6.5c28.69,10.77,54.22,29.14,74.88,51.6s36.92,48.7,50.24,76c3.2,6.89,6.33,13.86,9.37,20.76s5.87,13.85,9.07,20.65l4.7,10.24,4.93,10.14c3.21,6.79,6.81,13.38,10.24,20.06,7.19,13.18,14.66,26.21,22.9,38.74a406.41,406.41,0,0,0,26.67,36.14,312.43,312.43,0,0,0,66.37,60,368.51,368.51,0,0,0,38.87,22.62c13.4,6.78,27.16,12.9,41.06,18.68,27.83,11.52,56.37,21.38,84.76,31.62a.72.72,0,0,1-.47,1.37c-14.34-4.71-28.68-9.42-43-14.35s-28.52-10-42.6-15.51c-28.17-11-55.76-23.92-81.23-40.56a308.14,308.14,0,0,1-68.09-60.3,415.4,415.4,0,0,1-27.24-36.54c-8.41-12.65-16-25.78-23.36-39.06-3.5-6.73-7.16-13.37-10.44-20.21l-5-10.2-4.79-10.3c-3.26-6.84-6.16-13.83-9.24-20.75s-6.05-13.72-9.19-20.53c-13-26.93-28.78-52.69-48.93-74.72a220.61,220.61,0,0,0-33.18-29.78,180.16,180.16,0,0,0-39-21.41A179.3,179.3,0,0,0,132.91,842c-3.6-1-7.27-1.63-10.92-2.37-3.68-.57-7.36-1.22-11.08-1.55a154.44,154.44,0,0,0-22.35-.86,123,123,0,0,0-22.16,2.57l-.09,0a1.21,1.21,0,0,1-.55-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.58,666.26a65.72,65.72,0,0,0,15.3.52A83,83,0,0,0,103,664.29a87.64,87.64,0,0,0,27.57-12.81,106.92,106.92,0,0,0,11.84-9.59,123.23,123.23,0,0,0,10.35-11.2c1.58-2,3.15-4,4.65-6.07l4.45-6.38a112.31,112.31,0,0,1,10.25-12.3,159,159,0,0,1,52.15-36,119.37,119.37,0,0,1,31-8.43,98.16,98.16,0,0,1,16.18-.71,85.8,85.8,0,0,1,16.1,2.28c2.66.59,5.25,1.43,7.84,2.25s5.1,1.89,7.55,3.07A84.67,84.67,0,0,1,317,576.54,108.11,108.11,0,0,1,340,598.91c13,17,22,36.42,28.79,56.29a311.22,311.22,0,0,1,8.63,30.27c2.44,10.18,4.4,20.47,6.08,30.78a623.3,623.3,0,0,1,6.55,62.23,1,1,0,0,1-.92,1,1,1,0,0,1-1-.87c-2.28-20.66-5-41.26-9.05-61.6-2-10.16-4.17-20.29-6.87-30.27s-5.57-19.9-9.12-29.56c-7-19.3-16-38.05-28.54-54A118.78,118.78,0,0,0,324.39,592a90.14,90.14,0,0,0-11.55-9.59A78.08,78.08,0,0,0,299.89,575c-2.25-1.07-4.59-1.91-6.92-2.78s-4.73-1.51-7.16-2a85.07,85.07,0,0,0-14.75-2.08,92.54,92.54,0,0,0-15,.59A112.71,112.71,0,0,0,227,576.48,155.64,155.64,0,0,0,176.5,610.2a105.67,105.67,0,0,0-10,11.44L161.9,628q-2.42,3.16-5,6.2a126.29,126.29,0,0,1-11.17,11.38,112.31,112.31,0,0,1-12.7,9.65,90.92,90.92,0,0,1-29.3,12.15c-10.36,2.21-21.09,2.72-31.51.47a.79.79,0,0,1,.29-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M175.19,804l684-11.56c27.54-.46,49.65,23.16,48,51.3l-23.54,404.89c-1.29,22.16-19.12,39.51-40.8,39.73l-657.5,6.5c-16.24.16-29.66-12.93-30.28-29.55L139.36,842.76C138.58,821.85,154.75,804.37,175.19,804Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M185.68,814.34l666.16-11a46.07,46.07,0,0,1,46.75,48.8l-22.93,385.21a40.18,40.18,0,0,1-39.73,37.8l-640.34,6.19a29.23,29.23,0,0,1-29.49-28.11l-15.32-402A35.51,35.51,0,0,1,185.68,814.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.14,827.61l634.34-10.47A43.88,43.88,0,0,1,877,863.62l-21.84,366.81a38.26,38.26,0,0,1-37.83,36l-609.76,5.89a27.81,27.81,0,0,1-28.07-26.77L164.91,862.71A33.82,33.82,0,0,1,198.14,827.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M853.38,803l-668.95,11a35.66,35.66,0,0,0-35.05,37l1.08,28.34H898.69L900.32,852A46.26,46.26,0,0,0,853.38,803Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.46,827.76a6,6,0,1,1-6-6A6,6,0,0,1,205.46,827.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.46,845.39a6,6,0,1,1-6-6A6,6,0,0,1,205.46,845.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.46,863a6,6,0,1,1-6-6A6,6,0,0,1,205.46,863Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 311.87,
    cy: 1030.25,
    r: 95.35,
    transform: "translate(-637.15 522.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 311.87,
    cy: 1030.25,
    r: 21.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363,1064.68A61.25,61.25,0,1,1,312.33,969c1,0,2.07,0,3.09.08V953.55c-1,0-2.05-.07-3.09-.07a76.77,76.77,0,1,0,63.23,120.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M480.08,957.73a14,14,0,1,1-13.88-14.07A14,14,0,0,1,480.08,957.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M479.61,957.73a13.51,13.51,0,1,1-13.41-13.6A13.5,13.5,0,0,1,479.61,957.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M453.66,956.89a11.46,11.46,0,0,1,.19-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M455,952a12.47,12.47,0,0,1,11.18-6.78,12.81,12.81,0,0,1,2.25.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M480.08,1042.43a14,14,0,1,1-13.88-14.06A14,14,0,0,1,480.08,1042.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M479.61,1042.43a13.51,13.51,0,1,1-13.41-13.6A13.49,13.49,0,0,1,479.61,1042.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M453.66,1041.59a11.46,11.46,0,0,1,.19-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M455,1036.65a12.47,12.47,0,0,1,11.18-6.78,11.92,11.92,0,0,1,2.25.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M480.08,1127.13a14,14,0,1,1-13.88-14.06A14,14,0,0,1,480.08,1127.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 466.11,
    cy: 1127.04,
    r: 13.51,
    transform: "translate(-660.42 659.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M453.66,1126.29a11.46,11.46,0,0,1,.19-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M455,1121.35a12.47,12.47,0,0,1,11.18-6.78,11.92,11.92,0,0,1,2.25.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M501.57,957l.07,2.38c.17,6.44,4.2,11.55,9.11,11.58l271.87.57c5.08,0,9.2-5.37,9.19-12h0c0-6.52-4-11.85-9-12l-271.93-2.95C505.65,944.44,501.39,950.11,501.57,957Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M501.57,1041.29l.07,2.38c.17,6.44,4.2,11.55,9.11,11.58l271.87.56c5.08,0,9.2-5.36,9.19-12h0c0-6.53-4-11.85-9-12l-271.93-3C505.65,1028.72,501.39,1034.4,501.57,1041.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M501.57,1125.58l.07,2.38c.17,6.44,4.2,11.55,9.11,11.58l271.87.56c5.08,0,9.2-5.37,9.19-12h0c0-6.53-4-11.85-9-12l-271.93-2.95C505.65,1113,501.39,1118.69,501.57,1125.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M808.5,1192l-583.63,10.35a16.85,16.85,0,0,0-16.34,19.52l2.57,16.1a16.85,16.85,0,0,0,16.71,14.19l578.48-2.27a16.86,16.86,0,0,0,16.7-15.08l2.57-24.18A16.86,16.86,0,0,0,808.5,1192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M681.28,1112.5c-2.29-2.26-4.71-4.77-7.39-7.69l-2.52-2.75,3.57,1.09c3,.92,6.06,1.7,9.1,2.32l1.14.23-2.75,7.93Zm-3.41-6.4q1.92,2,3.69,3.82l.94-2.7C681,1106.89,679.41,1106.51,677.87,1106.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.4,264.29c28,43.88,73.89,77.07,119.57,104.21,59.75,35.48,124.71,67.09,167.31,122,44.49,57.35,58.41,132.84,60.17,205.4s-7.2,145.24-2.21,217.65c4.74,68.87,24,140,70.4,190.58-45.11-13.84-76.65-58.79-88.23-105.24-12.36-49.53-6.87-101.48-4.53-152.48S582.72,741.88,558.3,697c-47.92-88-164.2-112.08-233.16-184.75-35.67-37.6-57.05-86.9-68.81-137.37-8-34.4-11.83-69.54-14.31-104.82C241.33,260.33,254.12,256,259.4,264.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M433.09,560.55l-4.22-362.91a33.07,33.07,0,0,1,38-33.08l98.49,14.91a33.07,33.07,0,0,1,28.12,32.7V543.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2263,928.63c6.5,1.27,10.82-6.5,6.38-11.52-25.39-28.75-81.25-80-147.09-65.37-90.23,20-149,74.12-207.4,238.06-56.79,159.35-240.39,246.41-292.36,257.81a5.12,5.12,0,0,0-4,5.24h0a5.15,5.15,0,0,0,6.31,4.88c36.34-8.92,226.78-58.07,314.08-128.52C2030.58,1155.25,2137.6,904.07,2263,928.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2200.51,896.91a130.55,130.55,0,0,0-23.44-2.37,164.73,164.73,0,0,0-23.6,1.24c-3.92.41-7.8,1.15-11.67,1.81-3.85.84-7.72,1.57-11.5,2.66A180.44,180.44,0,0,0,2067,930.78a234.52,234.52,0,0,0-34.64,31.88c-21,23.52-37.35,50.94-50.76,79.56-3.23,7.24-6.31,14.49-9.47,21.82s-6.16,14.82-9.55,22.1l-4.95,11-5.2,10.87c-3.4,7.28-7.2,14.36-10.83,21.53-7.61,14.16-15.54,28.17-24.32,41.68a437.56,437.56,0,0,1-28.46,39.06,325.92,325.92,0,0,1-71.53,64.7c-26.84,17.91-55.93,32-85.66,43.85s-60,22.21-90.31,32.46a.92.92,0,0,1-.61-1.74c29.9-11.27,60-22.1,89.27-34.69s57.91-26.71,84-44.77a331.61,331.61,0,0,0,69.37-64.32,428,428,0,0,0,27.73-38.55c8.56-13.34,16.3-27.22,23.74-41.24,3.54-7.11,7.26-14.13,10.58-21.36l5.08-10.78,4.84-10.9c3.31-7.23,6.23-14.64,9.34-22s6.38-14.78,9.68-22.11c13.82-29.11,30.67-57.09,52.42-81.23s48.6-43.83,79-55.57a175.5,175.5,0,0,1,23.27-7.13c3.93-1,7.94-1.63,11.93-2.37,4-.56,8-1.2,12.06-1.49,16.13-1.44,32.42-.95,48.32,2.89a1.53,1.53,0,0,1-.67,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1635.84,1169.8l-2.75-7.93,1.14-.23c3-.62,6.1-1.4,9.1-2.32l3.57-1.1-2.52,2.75c-2.68,2.92-5.1,5.44-7.39,7.7Zm-.07-6.41.94,2.7c1.18-1.2,2.41-2.46,3.69-3.82C1638.86,1162.68,1637.31,1163.05,1635.77,1163.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1765.78,1185.75l-.13-5.52.75.08c2,.22,4.11.35,6.17.37l2.46,0-2.13,1.22c-2.26,1.29-4.28,2.39-6.17,3.34Zm1.24-4,0,1.88c1-.51,2-1.06,3.08-1.66C1769.1,1181.89,1768.05,1181.82,1767,1181.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2200.88,738c-26.34,21.9-61.74,33.52-95.8,41.39-44.55,10.29-91.6,17.11-129.28,43-39.36,27-63.19,71.57-78.81,116.7s-24.55,92.48-42.16,136.87c-16.75,42.21-43.07,82.93-82.26,105.37,31,.35,59.8-21.52,76.36-48.31,17.66-28.58,24.61-62.24,33.35-94.67s20.38-65.69,44.66-88.9c47.64-45.55,125.35-37.41,183.11-69.16,29.88-16.43,53.15-43,70.62-72.34,11.9-20,21.33-41.21,29.94-62.83A6.22,6.22,0,0,0,2200.88,738Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1983.22,699.59c-8.67-14.32-19.39-27.21-30.63-39.65a5.56,5.56,0,0,0-9.68,3.86c.43,21.57-9.8,43.49-23.12,61.14-17,22.48-38.93,40.94-54.83,64.18-32.72,47.85-35.81,110.07-28.8,167.6s23,114.08,24.16,172c.58,27.63-2.4,56-14.36,80.86-11.74,24.47-33.22,45.29-59.61,51.39a1.29,1.29,0,0,0-.92,1.71h0a1.29,1.29,0,0,0,1,.82c33.65,5.22,66.51-20.23,79.7-51.72,13.29-31.72,10.77-67.73,5-101.64s-14.51-67.75-13-102.1a173.15,173.15,0,0,1,34.19-95.56c18.74-25,43.87-44.39,65.68-66.78s41.13-49.78,43.32-81C2003,741.91,1995.09,719.19,1983.22,699.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1954.58,707.82a69.77,69.77,0,0,1-1,9.42c-.51,3.11-1.16,6.19-1.92,9.24a131.54,131.54,0,0,1-5.81,17.93c-1.09,3-2.45,5.79-3.7,8.68-.61,1.45-1.36,2.83-2.06,4.24l-2.12,4.22c-1.52,2.75-3.12,5.46-4.68,8.2l-5.09,8c-1.8,2.58-3.67,5.1-5.51,7.66-.89,1.29-1.92,2.48-2.9,3.72l-3,3.67c-1.95,2.49-4,4.79-6,7.16s-4,4.72-6,7.09A349.6,349.6,0,0,0,1882,836.27a176.49,176.49,0,0,0-17.32,32.45c-2.47,5.64-4.21,11.55-6.12,17.39-1.47,6-3.21,11.9-4.17,18-2.47,12.09-3.46,24.45-4.37,36.8-.27,6.19-.41,12.39-.58,18.58l.19,18.62v0a.89.89,0,0,1-1.77.06c-1.54-24.84-1.32-50,3-74.73a173.87,173.87,0,0,1,27.49-69.65,348.42,348.42,0,0,1,22.87-29.77c4-4.81,8.11-9.5,12-14.28l2.91-3.57c1-1.2,2-2.36,2.86-3.62,1.8-2.49,3.65-5,5.43-7.46l5.1-7.68c1.56-2.64,3.17-5.27,4.7-7.93s3-5.37,4.33-8.14,2.75-5.5,3.9-8.35a157.47,157.47,0,0,0,6.38-17.31c.91-2.94,1.7-5.92,2.37-8.92a81.53,81.53,0,0,0,1.59-9v-.06a.88.88,0,0,1,1.76.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1747.48,1241.51a24.5,24.5,0,0,1-24.44,24.42H401.58a24.5,24.5,0,0,1-24.44-24.42l-11-759.41c0-13.42,15.82-39.64,44.82-37.67L1702.44,411a61.59,61.59,0,0,1,63.19,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1723.35,1218.09a23.18,23.18,0,0,1-23.11,23.12H433.45a23.18,23.18,0,0,1-23.12-23.12L400,528.69c1.22-41.48,37.59-56.39,59.64-55.51L1697.4,440a43.21,43.21,0,0,1,44.36,44.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M424,888.19a1,1,0,0,1-1-1l-.82-55.91a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1l.82,55.91a1,1,0,0,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M422,751.18a1,1,0,0,1-1-1l-3.15-214.13c.06-14,4.38-25.26,12.83-33.35,15.43-14.79,39.63-14,40.65-14l395.33-10.61a1,1,0,0,1,1,1,1,1,0,0,1-1,1L471.34,490.72c-1.07-.05-24.45-.76-39.27,13.44-8,7.71-12.15,18.44-12.21,31.9L423,750.17a1,1,0,0,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M466.14,1179.85c1.32-57,.83-561.55-2.44-605.13S528.3,523,632.5,518.07s983.35-24.32,1006-26.16c50.88-4.12,61.41,71.93,56.32,237-3.82,124-10.16,328.38-13.08,422.35a51.85,51.85,0,0,1-51.73,50.26c-211.56.58-1022.41,2.9-1076.39,4.51C491.49,1207.91,465.61,1202.44,466.14,1179.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1821.32,1329H330.09a33.46,33.46,0,0,1-33.36-33.36h0a33.46,33.46,0,0,1,33.36-33.37H1821.32a33.46,33.46,0,0,1,33.36,33.37h0A33.46,33.46,0,0,1,1821.32,1329Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2024,618a.88.88,0,0,1-.81-.53.89.89,0,0,1,.45-1.18c1.08-.48,2.16-1,3.23-1.47a.89.89,0,1,1,.75,1.62c-1.08.5-2.16,1-3.26,1.48A.78.78,0,0,1,2024,618Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1952.52,634a.89.89,0,0,1,0-1.78c2.32-.06,4.67-.16,7-.3a.89.89,0,0,1,.94.83.88.88,0,0,1-.83.95c-2.33.14-4.7.25-7,.3Zm-11.41-.06h0c-2.34-.08-4.71-.21-7-.38a.91.91,0,0,1-.83-1,.88.88,0,0,1,1-.82c2.31.17,4.66.3,7,.38a.9.9,0,0,1,0,1.79Zm29.78-1.28a.89.89,0,0,1-.88-.78.88.88,0,0,1,.78-1c2.3-.29,4.63-.61,6.92-1a.89.89,0,1,1,.28,1.76c-2.31.37-4.66.7-7,1Zm-48.13-.3h-.12c-2.33-.31-4.67-.68-7-1.08a.88.88,0,0,1-.72-1,.9.9,0,0,1,1-.73c2.27.4,4.6.76,6.9,1.07a.89.89,0,0,1-.12,1.78Zm66.29-2.82a.89.89,0,0,1-.19-1.76c2.26-.5,4.54-1.06,6.79-1.65a.89.89,0,0,1,.45,1.73c-2.27.59-4.57,1.15-6.85,1.66A.68.68,0,0,1,1989.05,629.5Zm-84.4-.56-.2,0c-2.29-.55-4.59-1.14-6.85-1.78a.89.89,0,1,1,.48-1.71c2.24.62,4.52,1.21,6.78,1.75a.89.89,0,0,1-.21,1.76Zm102.17-4.33a.88.88,0,0,1-.85-.61.89.89,0,0,1,.57-1.13c2.19-.72,4.4-1.49,6.59-2.31a.9.9,0,1,1,.62,1.68c-2.2.82-4.45,1.6-6.66,2.33A.84.84,0,0,1,2006.82,624.61Zm-119.88-.84a.93.93,0,0,1-.29,0c-2.23-.77-4.46-1.59-6.64-2.44a.89.89,0,0,1-.5-1.16.88.88,0,0,1,1.15-.5c2.15.84,4.36,1.65,6.57,2.42a.89.89,0,0,1-.29,1.73Zm-17.11-6.9a.87.87,0,0,1-.38-.08c-2.13-1-4.27-2-6.35-3.08a.89.89,0,0,1,.81-1.59c2.06,1,4.17,2.07,6.29,3a.89.89,0,0,1-.37,1.7Zm-16.34-8.54a.92.92,0,0,1-.45-.12c-2-1.19-4-2.43-6-3.69a.89.89,0,0,1,1-1.5c2,1.24,4,2.47,6,3.65a.89.89,0,0,1,.32,1.22A.9.9,0,0,1,1853.49,608.33Zm-15.42-10.1a.92.92,0,0,1-.52-.17c-1.89-1.38-3.78-2.81-5.63-4.26a.89.89,0,0,1,1.11-1.4c1.82,1.43,3.7,2.85,5.57,4.21a.9.9,0,0,1,.2,1.25A.91.91,0,0,1,1838.07,598.23Zm-14.34-11.56a.88.88,0,0,1-.59-.22c-1.76-1.57-3.5-3.18-5.18-4.79a.89.89,0,1,1,1.23-1.29c1.67,1.6,3.39,3.2,5.13,4.74a.89.89,0,0,1-.59,1.56Zm-13.15-12.9a.87.87,0,0,1-.65-.29c-1.59-1.72-3.17-3.49-4.69-5.26a.89.89,0,1,1,1.36-1.16c1.5,1.75,3.06,3.51,4.64,5.21a.9.9,0,0,1,0,1.26A.89.89,0,0,1,1810.58,573.77Zm-11.81-14.12a.88.88,0,0,1-.71-.35c-1.42-1.87-2.81-3.79-4.15-5.7a.9.9,0,0,1,.22-1.24.91.91,0,0,1,1.25.22c1.32,1.89,2.7,3.79,4.1,5.64a.89.89,0,0,1-.71,1.43Zm-10.37-15.2a.88.88,0,0,1-.76-.43c-1.22-2-2.42-4-3.56-6.07a.89.89,0,0,1,.34-1.21.9.9,0,0,1,1.22.34c1.12,2,2.31,4,3.52,6a.89.89,0,0,1-.29,1.23A.9.9,0,0,1,1788.4,544.45Zm-8.81-16.14a.9.9,0,0,1-.8-.5c-1-2.11-2-4.27-3-6.41a.9.9,0,0,1,.46-1.18.89.89,0,0,1,1.17.46c.93,2.12,1.91,4.26,2.92,6.35a.89.89,0,0,1-.41,1.19A.92.92,0,0,1,1779.59,528.31Zm-7.18-17a.89.89,0,0,1-.84-.59c-.81-2.2-1.58-4.45-2.3-6.67a.89.89,0,0,1,1.69-.55c.72,2.2,1.48,4.42,2.28,6.61a.89.89,0,0,1-.53,1.14A.8.8,0,0,1,1772.41,511.35Zm-5.47-17.59a.91.91,0,0,1-.87-.67c-.58-2.27-1.13-4.58-1.63-6.86a.9.9,0,0,1,1.75-.38c.49,2.26,1,4.55,1.61,6.79a.89.89,0,0,1-.64,1.09Zm-3.72-18a.9.9,0,0,1-.88-.76c-.35-2.3-.67-4.65-.95-7a.9.9,0,0,1,1.78-.2c.27,2.31.58,4.64.94,6.92a.9.9,0,0,1-.75,1Zm-1.93-18.33a.89.89,0,0,1-.89-.84c-.13-2.34-.22-4.71-.27-7.05a.89.89,0,0,1,.88-.91h0a.9.9,0,0,1,.9.88c0,2.31.13,4.66.26,7a.89.89,0,0,1-.84.94Zm-.14-18.42h0a.9.9,0,0,1-.86-.93c.1-2.34.24-4.71.43-7.05a.9.9,0,0,1,1-.82.89.89,0,0,1,.81,1c-.18,2.32-.32,4.67-.41,7A.9.9,0,0,1,1761.15,439Zm1.66-18.36h-.13a.88.88,0,0,1-.75-1c.32-2.32.7-4.67,1.11-7a.89.89,0,0,1,1.76.31c-.41,2.29-.78,4.61-1.11,6.91A.88.88,0,0,1,1762.81,420.61Zm3.47-18.1a.75.75,0,0,1-.21,0,.9.9,0,0,1-.66-1.08c.56-2.27,1.16-4.57,1.8-6.82a.89.89,0,0,1,1.11-.62.9.9,0,0,1,.61,1.11c-.63,2.23-1.23,4.5-1.78,6.75A.9.9,0,0,1,1766.28,402.51Zm5.25-17.66a1,1,0,0,1-.3-.05.89.89,0,0,1-.55-1.14c.78-2.21,1.61-4.44,2.47-6.61a.89.89,0,0,1,1.66.66c-.85,2.15-1.67,4.35-2.44,6.54A.9.9,0,0,1,1771.53,384.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1778.53,367.71a.87.87,0,0,1-.38-.08.9.9,0,0,1-.43-1.19c.51-1.08,1-2.16,1.55-3.23a.91.91,0,0,1,1.2-.41.89.89,0,0,1,.4,1.2c-.52,1.06-1,2.13-1.53,3.2A.89.89,0,0,1,1778.53,367.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1883.63,271.16a.89.89,0,0,1-.31-1.73c1.12-.41,2.25-.81,3.38-1.2a.88.88,0,0,1,1.13.55.89.89,0,0,1-.55,1.13l-3.35,1.19A.8.8,0,0,1,1883.63,271.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2119,523.19a.94.94,0,0,1-.37-.07.9.9,0,0,1-.45-1.18c1-2.18,1.92-4.4,2.8-6.6a.89.89,0,1,1,1.66.66c-.89,2.23-1.85,4.47-2.83,6.66A.88.88,0,0,1,2119,523.19Zm6.84-17.62a.87.87,0,0,1-.28-.05.88.88,0,0,1-.57-1.12c.74-2.26,1.46-4.56,2.12-6.85a.89.89,0,1,1,1.71.49c-.66,2.31-1.38,4.64-2.14,6.92A.89.89,0,0,1,2125.88,505.57Zm5-18.23a.62.62,0,0,1-.19,0,.89.89,0,0,1-.68-1.06c.51-2.32,1-4.69,1.41-7a.89.89,0,0,1,1-.72.9.9,0,0,1,.72,1c-.43,2.37-.91,4.76-1.43,7.1A.89.89,0,0,1,2130.89,487.34ZM2134,468.7h-.11a.89.89,0,0,1-.78-1c.28-2.36.51-4.76.69-7.13a.89.89,0,1,1,1.78.13c-.18,2.4-.42,4.82-.7,7.21A.89.89,0,0,1,2134,468.7Zm1.23-18.87h0a.88.88,0,0,1-.87-.9c0-.91,0-1.83,0-2.74,0-1.48,0-2.95-.06-4.44a.9.9,0,0,1,1.79,0c0,1.5.05,3,.05,4.48,0,.92,0,1.84,0,2.76A.9.9,0,0,1,2135.26,449.83Zm-.67-18.89a.89.89,0,0,1-.89-.82c-.2-2.37-.45-4.77-.75-7.13a.9.9,0,0,1,1.78-.21c.29,2.38.54,4.8.75,7.19a.89.89,0,0,1-.82,1Zm-2.54-18.72a.89.89,0,0,1-.88-.73c-.44-2.35-.93-4.71-1.45-7a.89.89,0,1,1,1.74-.39c.53,2.33,1,4.71,1.46,7.08a.89.89,0,0,1-.71,1Zm-4.41-18.38a.89.89,0,0,1-.86-.64c-.67-2.28-1.4-4.58-2.16-6.83a.9.9,0,0,1,.56-1.13.88.88,0,0,1,1.13.56c.77,2.27,1.5,4.6,2.18,6.9a.9.9,0,0,1-.6,1.11ZM2121.39,376a.9.9,0,0,1-.83-.55c-.9-2.21-1.86-4.42-2.84-6.59a.9.9,0,0,1,.44-1.18.89.89,0,0,1,1.18.45c1,2.18,2,4.42,2.87,6.64a.88.88,0,0,1-.49,1.16A.78.78,0,0,1,2121.39,376Zm-8-17.09a.88.88,0,0,1-.78-.48c-1.12-2.09-2.29-4.19-3.49-6.24a.89.89,0,0,1,1.54-.9c1.21,2.07,2.4,4.19,3.52,6.31a.9.9,0,0,1-.79,1.31Zm-9.7-16.18a.88.88,0,0,1-.74-.4c-1.33-2-2.71-3.94-4.1-5.86a.89.89,0,1,1,1.44-1.05c1.41,1.93,2.8,3.93,4.14,5.92a.89.89,0,0,1-.25,1.23A.82.82,0,0,1,2103.66,342.74Zm-11.3-15.13a.88.88,0,0,1-.69-.33c-1.52-1.84-3.09-3.66-4.67-5.42a.89.89,0,1,1,1.33-1.19c1.59,1.78,3.18,3.62,4.72,5.48a.9.9,0,0,1-.69,1.46Zm-12.77-13.92a.89.89,0,0,1-.62-.26c-1.7-1.68-3.45-3.34-5.2-4.93a.9.9,0,0,1-.06-1.26.89.89,0,0,1,1.26-.06c1.77,1.61,3.53,3.29,5.25,5a.89.89,0,0,1-.63,1.53Zm-14.1-12.58a.86.86,0,0,1-.56-.2c-1.85-1.49-3.76-3-5.67-4.39a.89.89,0,0,1,1.07-1.43c1.92,1.44,3.85,2.93,5.72,4.43a.91.91,0,0,1,.14,1.26A.9.9,0,0,1,2065.49,301.11Zm-15.3-11.1a.91.91,0,0,1-.49-.15c-2-1.3-4-2.57-6.08-3.8a.89.89,0,0,1-.31-1.22.91.91,0,0,1,1.23-.31c2.06,1.24,4.13,2.53,6.14,3.84a.89.89,0,0,1,.26,1.23A.91.91,0,0,1,2050.19,290Zm-16.34-9.52a.86.86,0,0,1-.41-.1c-2.12-1.09-4.29-2.16-6.44-3.16a.89.89,0,1,1,.76-1.62c2.17,1,4.36,2.09,6.5,3.2a.89.89,0,0,1-.41,1.68Zm-17.23-7.81a.71.71,0,0,1-.32-.07c-2.23-.87-4.49-1.72-6.73-2.5A.89.89,0,0,1,2009,269a.88.88,0,0,1,1.13-.54c2.27.79,4.55,1.64,6.8,2.52a.9.9,0,0,1,.5,1.16A.89.89,0,0,1,2016.62,272.68Zm-17.93-6a1.07,1.07,0,0,1-.25,0c-2.29-.65-4.63-1.25-7-1.81a.88.88,0,0,1-.66-1.07.89.89,0,0,1,1.07-.66c2.34.56,4.71,1.17,7,1.82a.89.89,0,0,1-.24,1.75Zm-100.52-.14a.89.89,0,0,1-.24-1.75c2.32-.64,4.68-1.25,7-1.79a.89.89,0,0,1,.41,1.73c-2.31.55-4.65,1.14-6.95,1.78Zm82.07-4-.16,0c-2.33-.4-4.72-.77-7.08-1.08a.91.91,0,0,1-.77-1,.89.89,0,0,1,1-.76c2.38.32,4.79.69,7.15,1.09a.9.9,0,0,1-.15,1.78Zm-63.62-.07a.89.89,0,0,1-.15-1.77c2.36-.4,4.76-.76,7.15-1.08a.89.89,0,1,1,.24,1.77c-2.37.31-4.76.67-7.09,1.07Zm44.86-2.21h-.07c-2.36-.16-4.77-.28-7.15-.36a.89.89,0,0,1-.87-.92.89.89,0,0,1,.92-.86c2.41.07,4.84.2,7.23.37a.89.89,0,0,1-.06,1.78Zm-26.09,0a.89.89,0,0,1-.06-1.78c2.39-.16,4.82-.28,7.23-.36a.87.87,0,0,1,.91.86.88.88,0,0,1-.86.92c-2.38.08-4.79.2-7.16.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2112.19,536.94a.84.84,0,0,1-.43-.11.89.89,0,0,1-.35-1.21c.57-1,1.13-2.08,1.68-3.12a.89.89,0,1,1,1.58.83c-.56,1-1.12,2.11-1.7,3.15A.88.88,0,0,1,2112.19,536.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2064.42,530.5a2.24,2.24,0,0,0,.31-2.59L2051.54,504a119,119,0,0,0,13-36.34l25.35-10.18a2.26,2.26,0,0,0,1.41-2.2l-1.64-32.75a2.24,2.24,0,0,0-1.62-2l-26.24-7.61A119.46,119.46,0,0,0,2045.23,378L2056,352.86a2.24,2.24,0,0,0-.55-2.55l-24.32-22a2.25,2.25,0,0,0-2.59-.3l-24,13.19a119.29,119.29,0,0,0-36.33-13L1958,302.87a2.24,2.24,0,0,0-2.19-1.4l-32.75,1.64a2.26,2.26,0,0,0-2,1.62l-7.6,26.24a118.72,118.72,0,0,0-34.85,16.54l-25.15-10.73a2.25,2.25,0,0,0-2.55.56l-22,24.32a2.22,2.22,0,0,0-.3,2.59l13.18,23.94a119,119,0,0,0-13,36.34l-25.35,10.18a2.26,2.26,0,0,0-1.41,2.2l1.65,32.75a2.21,2.21,0,0,0,1.61,2l26.24,7.61a119.46,119.46,0,0,0,16.54,34.85l-10.72,25.14a2.24,2.24,0,0,0,.56,2.55l24.31,22a2.25,2.25,0,0,0,2.59.3l24-13.19a119.29,119.29,0,0,0,36.33,13l10.19,25.34a2.25,2.25,0,0,0,2.2,1.41l32.74-1.64a2.26,2.26,0,0,0,2-1.62l7.6-26.24a118.89,118.89,0,0,0,34.86-16.54l25.14,10.73a2.26,2.26,0,0,0,2.55-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1946.62,476.55a30.47,30.47,0,1,1,29.15-39.39h0a30.49,30.49,0,0,1-29.15,39.39Zm.07-58.26a27.81,27.81,0,0,0-26.59,35.93,27.77,27.77,0,1,0,53.11-16.28h0a27.79,27.79,0,0,0-26.52-19.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1946.06,526.12a80.57,80.57,0,0,1-80.32-76.44c-.07-1.36-.1-2.72-.1-4.07a80.46,80.46,0,0,1,160.82-4c.07,1.36.1,2.71.1,4.07a80.84,80.84,0,0,1-1,13l-2.64-.43a79,79,0,0,0,1-12.6c0-1.31,0-2.63-.1-3.94h0a77.89,77.89,0,0,0-77.64-73.89c-1.31,0-2.62,0-3.94.1a77.88,77.88,0,0,0-73.89,77.64c0,1.31,0,2.62.1,3.94a77.79,77.79,0,0,0,120.91,60.78l1.49,2.23A80.35,80.35,0,0,1,1950.13,526C1948.76,526.08,1947.41,526.12,1946.06,526.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1839.52,314.26l-8.43-12.79a66.8,66.8,0,0,0,5.63-20.86l13.71-6.82a1.28,1.28,0,0,0,.69-1.29l-2.38-18.22a1.24,1.24,0,0,0-1-1.07l-15-3.08A66.82,66.82,0,0,0,1822,231.4l4.88-14.52a1.26,1.26,0,0,0-.43-1.4l-14.56-11.2a1.26,1.26,0,0,0-1.46-.06l-12.79,8.43a66.79,66.79,0,0,0-20.87-5.63l-6.81-13.71a1.28,1.28,0,0,0-1.29-.69L1750.42,195a1.24,1.24,0,0,0-1.07,1l-3.08,15a66.82,66.82,0,0,0-18.73,10.79L1713,216.89a1.26,1.26,0,0,0-1.4.43l-11.21,14.56a1.26,1.26,0,0,0-.05,1.46l8.43,12.79a66.52,66.52,0,0,0-5.63,20.87l-13.71,6.81a1.26,1.26,0,0,0-.69,1.29l2.37,18.22a1.26,1.26,0,0,0,1,1.07l15,3.08a66.58,66.58,0,0,0,10.79,18.73L1713,330.72a1.26,1.26,0,0,0,.43,1.4L1728,343.33a1.26,1.26,0,0,0,1.46.05l12.79-8.43a66.53,66.53,0,0,0,20.86,5.63l6.82,13.71a1.26,1.26,0,0,0,1.29.69l18.22-2.37a1.26,1.26,0,0,0,1.07-1l3.08-15a66.58,66.58,0,0,0,18.73-10.79l14.52,4.88a1.26,1.26,0,0,0,1.4-.43l11.2-14.56A1.26,1.26,0,0,0,1839.52,314.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1770,291.45a17.68,17.68,0,1,1,6.47-1.24A17.67,17.67,0,0,1,1770,291.45Zm0-32.62A15,15,0,0,0,1756,279.31a15,15,0,0,0,27.67.44,14.84,14.84,0,0,0,.18-11.46h0A15,15,0,0,0,1769.92,258.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1833,350.36a.86.86,0,0,1-.68-.33.88.88,0,0,1,.11-1.25c.91-.76,1.81-1.54,2.68-2.31a.88.88,0,0,1,1.25.06.9.9,0,0,1-.06,1.26c-.88.79-1.8,1.59-2.73,2.36A.86.86,0,0,1,1833,350.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1770,373.2c-2.08,0-4.18-.07-6.26-.2a.88.88,0,0,1-.83-.94.89.89,0,0,1,.94-.84c2,.13,4.11.2,6.15.2h.89a.9.9,0,0,1,0,1.79Zm12.42-.79a.89.89,0,0,1-.12-1.78c2.32-.29,4.66-.68,7-1.15a.89.89,0,0,1,.36,1.75c-2.34.48-4.72.87-7.08,1.17Zm-30.08-.81-.16,0c-2.35-.43-4.7-.95-7-1.54a.89.89,0,1,1,.45-1.73c2.26.59,4.58,1.1,6.88,1.52a.89.89,0,0,1-.16,1.77Zm48.25-3.3a.89.89,0,0,1-.28-1.74c1.86-.61,3.73-1.29,5.56-2l1-.42a.9.9,0,0,1,1.17.48.91.91,0,0,1-.49,1.17l-1.07.43c-1.87.74-3.77,1.42-5.66,2A1,1,0,0,1,1800.54,368.3Zm-66.18-1.77a.87.87,0,0,1-.32-.06c-2.23-.86-4.44-1.81-6.59-2.83a.88.88,0,0,1-.43-1.18.89.89,0,0,1,1.19-.43c2.11,1,4.29,1.93,6.47,2.78a.89.89,0,0,1-.32,1.72Zm83.26-5.67a.88.88,0,0,1-.78-.46.89.89,0,0,1,.35-1.21c2-1.13,4.08-2.35,6-3.62a.89.89,0,0,1,1,1.49c-2,1.3-4.06,2.54-6.15,3.69A.81.81,0,0,1,1817.62,360.86Zm-99.92-2.66a.83.83,0,0,1-.47-.14c-2-1.26-4-2.61-5.94-4a.89.89,0,1,1,1-1.44c1.88,1.38,3.85,2.7,5.83,3.94a.89.89,0,0,1-.47,1.65Zm-14.8-11.31a.88.88,0,0,1-.6-.24c-1.75-1.62-3.45-3.32-5.08-5.06a.89.89,0,0,1,0-1.26.9.9,0,0,1,1.27,0c1.59,1.71,3.27,3.39,5,5a.9.9,0,0,1,0,1.26A.91.91,0,0,1,1702.9,346.89ZM1690.52,333a.87.87,0,0,1-.72-.36c-1.41-1.92-2.76-3.92-4-5.93a.89.89,0,1,1,1.51-.95c1.24,2,2.57,3.94,4,5.82a.9.9,0,0,1-.2,1.25A.85.85,0,0,1,1690.52,333ZM1681,317a.89.89,0,0,1-.81-.51c-1-2-1.84-4.06-2.66-6.13l-.18-.45a.89.89,0,0,1,1.66-.65l.18.45c.8,2,1.68,4.06,2.61,6a.88.88,0,0,1-.42,1.19A.84.84,0,0,1,1681,317Zm-6.38-17.5a.89.89,0,0,1-.87-.67c-.6-2.3-1.13-4.65-1.56-7a.9.9,0,0,1,1.76-.33c.42,2.3.94,4.61,1.53,6.87a.89.89,0,0,1-.64,1.09A.83.83,0,0,1,1674.6,299.49Zm-3-18.39a.9.9,0,0,1-.89-.83c-.14-2.14-.21-4.31-.21-6.45v-.72a.89.89,0,0,1,.89-.89h0a.9.9,0,0,1,.88.9v.71c0,2.1.07,4.23.21,6.33a.9.9,0,0,1-.84,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1672.18,262.42h-.11a.89.89,0,0,1-.77-1c.15-1.19.32-2.39.51-3.56a.89.89,0,1,1,1.76.29c-.19,1.15-.36,2.32-.5,3.49A.9.9,0,0,1,1672.18,262.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1710.57,196.06a.89.89,0,0,1-.53-1.6c1-.72,1.93-1.43,2.91-2.12a.89.89,0,0,1,1,1.46c-1,.68-1.93,1.37-2.86,2.08A.9.9,0,0,1,1710.57,196.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1868.28,280.13h0a.88.88,0,0,1-.84-.94c.1-1.79.15-3.62.15-5.41,0-.51,0-1,0-1.51a.89.89,0,0,1,.88-.91.91.91,0,0,1,.9.88c0,.51,0,1,0,1.54,0,1.82-.06,3.68-.16,5.51A.89.89,0,0,1,1868.28,280.13Zm-.7-18.32a.89.89,0,0,1-.88-.78c-.3-2.28-.69-4.58-1.15-6.83a.89.89,0,0,1,1.74-.36c.48,2.3.87,4.64,1.18,7a.89.89,0,0,1-.77,1Zm-4.09-17.87a.89.89,0,0,1-.85-.61c-.6-1.82-1.26-3.65-2-5.43-.14-.36-.28-.72-.43-1.08a.89.89,0,0,1,.49-1.16.88.88,0,0,1,1.16.49c.15.36.3.72.44,1.09.72,1.82,1.4,3.68,2,5.53a.91.91,0,0,1-.57,1.13A1,1,0,0,1,1863.49,243.94Zm-7.31-16.81a.92.92,0,0,1-.79-.46c-1.1-2-2.3-4-3.55-5.95a.89.89,0,1,1,1.5-1c1.27,2,2.49,4,3.62,6.06a.89.89,0,0,1-.35,1.21A1,1,0,0,1,1856.18,227.13ZM1845.88,212a.88.88,0,0,1-.68-.32c-1.47-1.77-3-3.52-4.6-5.18a.89.89,0,1,1,1.29-1.23c1.62,1.69,3.19,3.47,4.68,5.27a.89.89,0,0,1-.12,1.26A.86.86,0,0,1,1845.88,212ZM1833,199a.89.89,0,0,1-.57-.21c-1.77-1.47-3.61-2.89-5.48-4.24a.89.89,0,0,1-.21-1.24.91.91,0,0,1,1.25-.21c1.9,1.37,3.78,2.82,5.58,4.32A.89.89,0,0,1,1833,199Zm-15.12-10.36a.87.87,0,0,1-.44-.11c-2-1.11-4.08-2.17-6.17-3.15a.89.89,0,1,1,.76-1.62c2.12,1,4.24,2.08,6.28,3.21a.89.89,0,0,1-.43,1.67Zm-94.7-.62a.89.89,0,0,1-.42-1.68c2.06-1.1,4.18-2.15,6.33-3.12a.89.89,0,1,1,.73,1.63c-2.11.95-4.2,2-6.21,3.06A.84.84,0,0,1,1723.13,188Zm77.92-6.76a.92.92,0,0,1-.28-.05c-2.18-.73-4.41-1.39-6.65-2a.89.89,0,1,1,.45-1.73c2.27.59,4.55,1.26,6.76,2a.9.9,0,0,1,.57,1.13A.91.91,0,0,1,1801.05,181.25Zm-61-.4a.89.89,0,0,1-.27-1.74c2.24-.72,4.52-1.36,6.79-1.91a.88.88,0,0,1,1.08.65.9.9,0,0,1-.66,1.08c-2.23.54-4.47,1.17-6.67,1.87A.86.86,0,0,1,1740,180.85Zm43.19-3.77h-.12c-2.28-.31-4.6-.54-6.9-.69a.89.89,0,0,1-.83-.95.91.91,0,0,1,1-.83c2.34.15,4.7.39,7,.71a.89.89,0,0,1-.12,1.77Zm-25.29-.17a.89.89,0,0,1-.88-.78.9.9,0,0,1,.77-1c2.33-.28,4.69-.49,7-.61a.89.89,0,1,1,.1,1.78c-2.3.12-4.62.32-6.91.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1866.31,295l-.19,0a.88.88,0,0,1-.68-1.06c.24-1.14.46-2.31.66-3.47a.91.91,0,0,1,1-.73.9.9,0,0,1,.72,1c-.2,1.17-.43,2.36-.68,3.53A.9.9,0,0,1,1866.31,295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1769.58,319.26a45.67,45.67,0,1,1,45.32-51.56h0a45.82,45.82,0,0,1,.23,9.72l-2.67-.23c.1-1.17.15-2.36.15-3.55a42.13,42.13,0,0,0-.37-5.6c0-.18,0-.37-.07-.55a42.66,42.66,0,0,0-15.6-27.39l-.74-.58a43,43,0,0,0-69.21,34,40.66,40.66,0,0,0,.36,5.59,43,43,0,0,0,69.28,28.19l1.66,2.1a45.61,45.61,0,0,1-22.42,9.45A47.43,47.43,0,0,1,1769.58,319.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M979.32,935,859.57,847.25l120.07-97.46a8.1,8.1,0,0,0-10.21-12.58L841.21,841.29a8.09,8.09,0,0,0,.32,12.81l128.22,94A8.1,8.1,0,1,0,979.32,935Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1233.39,841.29,1105.16,737.21a8.1,8.1,0,1,0-10.2,12.58L1215,847.25,1095.27,935a8.1,8.1,0,1,0,9.58,13.06l128.22-94a8.09,8.09,0,0,0,.32-12.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1060,714.2a8.11,8.11,0,0,0-9.46,6.47l-47.35,251.69a8.09,8.09,0,1,0,15.91,3l47.36-251.69A8.11,8.11,0,0,0,1060,714.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1495.3,791.32c-2,95.92-8.62,426.81-5.48,544.07.34,12.42,8.85,22.39,19.47,22.8,52.52,2,245,7.11,331,2.89,17.89-.88,32.12-17.83,32.49-38.78,1.78-100.68,5.72-383.88-3.64-513.61-1.12-15.55-11.55-27.93-24.82-29.48-57.19-6.69-250.55-23.05-324.76-17.42C1506.12,762.81,1495.63,775.63,1495.3,791.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1518.74,820.75c-2.83,77.43-11.75,335-8.92,430.26.42,13.92,9.8,25.18,21.68,26,49,3.35,215.93,10.74,287.72,4,12.93-1.22,23.07-13.45,23.77-28.59,3.64-79,14.08-318.84,11.37-413-.43-15-10.38-27.29-23.18-28.63-53-5.57-230.39-18.8-291.4-14.91C1528.33,796.6,1519.23,807.34,1518.74,820.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1625.1,778.55h0c0,2.94,2,5.37,4.47,5.53,12.4.76,47.35,2.91,63,4,3.08.21,5.5-3,4.92-6.58l-.1-.6a5.08,5.08,0,0,0-4.21-4.46c-10.56-1.13-42.41-4.27-63.52-3.39C1627.09,773.13,1625.1,775.58,1625.1,778.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1823,954.62l.62-90.86c.07-11-7-20.2-16-20.88l-235.45-17.8c-9.55-.72-17.46,8.11-17.89,19.63,0,0-10.77,273.16-10.77,276.49h0l-3.86,107.25c-.43,11.53,7.15,21.23,16.72,21.53l247.15,7.56c9.56.29,17.48-9.24,17.56-20.76l1.17-168.63h0l.76-113.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1645.5,1093.19,1568.77,1037l76.94-62.45a5.19,5.19,0,0,0-6.54-8.06L1557,1033.14a5.19,5.19,0,0,0,.21,8.21l82.16,60.21a5.15,5.15,0,0,0,3.06,1,5.19,5.19,0,0,0,3.07-9.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1808.3,1033.14l-82.16-66.69a5.19,5.19,0,1,0-6.54,8.06l76.94,62.45-76.74,56.23a5.19,5.19,0,0,0,3.07,9.38,5.12,5.12,0,0,0,3.06-1l82.17-60.21a5.18,5.18,0,0,0,.2-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1697.2,951.71a5.19,5.19,0,0,0-6.06,4.14l-30.35,161.28a5.2,5.2,0,0,0,4.14,6.06,5.27,5.27,0,0,0,1.9,0,5.18,5.18,0,0,0,4.16-4.14l30.35-161.28A5.19,5.19,0,0,0,1697.2,951.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M671.28,1098.16l718.28-3.14A12.3,12.3,0,0,1,1402,1107.4l-1.54,251.41a12.3,12.3,0,0,1-12.66,12.24c-63.34-1.89-712.51-10.22-724.92-9.7s-5.6-198-3.77-251.31A12.3,12.3,0,0,1,671.28,1098.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1388.15,1360.66h-.06c-40.51-1.21-428.62-6.05-615.14-8.38-53.94-.67-92.92-1.16-103.22-1.3h-.41l-.07-.41c-4.4-24.81-4.32-107.85.23-240.17a1.91,1.91,0,0,1,1.89-1.84l718.28-3.14a1.91,1.91,0,0,1,1.38.57,1.87,1.87,0,0,1,.55,1.36l-1.53,251.42A1.91,1.91,0,0,1,1388.15,1360.66Zm-718-10.68c10.9.15,49.56.64,102.8,1.3,186.52,2.33,574.65,7.17,615.16,8.38h.05a.91.91,0,0,0,.88-.91l1.53-251.42a.87.87,0,0,0-.26-.65.9.9,0,0,0-.67-.27l-718.27,3.14a.91.91,0,0,0-.9.88C666,1242,665.85,1324.75,670.16,1350Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M702,1163.09h0c0,6.8,2.27,12.31,5.07,12.31H982.22c2.79,0,5.06-5.51,5.06-12.31h0c0-6.8-2.27-12.31-5.06-12.31H707.08C704.28,1150.78,702,1156.29,702,1163.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M702,1205.05h0c0,6.8,2.27,12.31,5.07,12.31H982.22c2.79,0,5.06-5.51,5.06-12.31h0c0-6.8-2.27-12.31-5.06-12.31H707.08C704.28,1192.74,702,1198.25,702,1205.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M702,1247h0c0,6.8,2.27,12.31,5.07,12.31H982.22c2.79,0,5.06-5.51,5.06-12.31h0c0-6.8-2.27-12.31-5.06-12.31H707.08C704.28,1234.71,702,1240.22,702,1247Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M702,1289h0c0,6.8,2.27,12.31,5.07,12.31H982.22c2.79,0,5.06-5.51,5.06-12.31h0c0-6.8-2.27-12.31-5.06-12.31H707.08C704.28,1276.68,702,1282.19,702,1289Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1056.99,
    cy: 1171.76,
    r: 47.86,
    transform: "translate(-370.79 1843.84) rotate(-73.16)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1175.94,
    cy: 1171.76,
    r: 47.86,
    transform: "translate(-484.14 1174.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1294.88,
    cy: 1173.33,
    r: 47.86,
    transform: "translate(-450.4 1259.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1085.43,1161.64a30.74,30.74,0,1,1-28.44-19.06c.52,0,1,0,1.55,0v-7.79c-.51,0-1,0-1.55,0a38.49,38.49,0,1,0,35.59,23.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1191.79,1199.34a30.74,30.74,0,1,1-16.38-56.76c.52,0,1,0,1.56,0v-7.79l-1.56,0a38.53,38.53,0,1,0,20.25,71.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1320.54,1190.61a30.74,30.74,0,1,1-25.43-48c.52,0,1,0,1.55,0v-7.79c-.51,0-1,0-1.55,0a38.53,38.53,0,1,0,31.74,60.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1096,1239.89h-78a8.87,8.87,0,0,0,0,17.73h78a8.87,8.87,0,0,0,0-17.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1214.93,1239.89h-78a8.87,8.87,0,0,0,0,17.73h78a8.87,8.87,0,1,0,0-17.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1255.89,1257.62h78a8.87,8.87,0,0,0,0-17.73h-78a8.87,8.87,0,1,0,0,17.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1009.13,
    y: 1267.47,
    width: 95.72,
    height: 69.93,
    rx: 8.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1128.08,
    y: 1267.47,
    width: 95.72,
    height: 69.93,
    rx: 8.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 1247.02,
    y: 1267.47,
    width: 95.72,
    height: 69.93,
    rx: 8.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M522.36,1220.63s-1.75,9.57-2.6,19a6.61,6.61,0,0,0,6.44,7.08c13,.52,40.84,1.54,50.82,1.11A2.12,2.12,0,0,0,579,1245h0a4.8,4.8,0,0,0-2.51-2.56l-46-20.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M520.93,1215l1.4,11.45s8,3.63,13.55-.46l-3.33-12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M522,999.82c-.6,3-3.24,149.16,12.87,214.67a2.21,2.21,0,0,1-1.34,2.58,41.06,41.06,0,0,1-13.13,2.59,3.94,3.94,0,0,1-3.92-2.75c-4.6-15.2-26.68-91.34-29.56-164.09-3.21-81.28,0-2.76,0-2.76l1.89-50.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M469.48,1225.63s-2.78,4.83-5.46,17.66a4,4,0,0,0,3.61,4.77c4.3.41,10.91.94,16.21.9a4,4,0,0,0,4.05-4.43c-.59-4.68-2.41-12.37-8.06-18.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M467,1210.9l3.27,17.31s3.24,2.34,9.64.64l-1.56-18.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M458.2,1004.31c-13.18,77.12,2.86,190.61,8.27,212.82a3.52,3.52,0,0,0,2.88,2.63,24.59,24.59,0,0,0,10.31-.4,3.21,3.21,0,0,0,2.36-2.92c.72-18-.58-128.21,11.7-171.78a9.91,9.91,0,0,1,3.93-5.46l23.84-16.43,1.83-26.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M542.18,858.17c-39.5-.63-83.08,10.06-83.08,10.06-11.77,66.61-2.05,143.44-2.05,143.44,30.57,7.77,65.07-4.76,65.07-4.76,5.08-27.84,28.79-106.19,28.79-106.19,19.3-2.32,35.2-7.72,48.29-14.86-10-11.22-14.7-25.5-16.74-34C568.49,856.12,554.36,858.37,542.18,858.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M658.85,801.77a7.72,7.72,0,0,0-8.79-2.4c-5.81,23.81-36.29,43.11-67.6,52.54,2,8.45,6.75,22.73,16.74,34C651.16,857.53,658.85,801.77,658.85,801.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M657.91,802.92c.4,1.25-4.3,3.16-7.07-2-.09-2.45-1.63-13-.12-15,8-10.64,23.66-24,23.66-24a3.52,3.52,0,0,1,.47,5l-7.58,7.65c1.59,2.77,3.52,5.12,4.42,8.47a10,10,0,0,1-1.05,7.57c-1.33,2.33-3.15,5.34-4.86,7.71A10.58,10.58,0,0,1,657.91,802.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M664,779.63l-6.9,5.67L654.89,791l6.16,6.62s2.07-11.21,3.6-13.63S665.39,780.34,664,779.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M474.25,905.31,459.1,868.23s-36.89,24.3-43,55.12a89.72,89.72,0,0,1,32.08,8.33C450.94,917.13,474.25,905.31,474.25,905.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M506.49,940.2s-41.42,22.7-55.39,3.32a14.82,14.82,0,0,1-2.88-11.84,89.72,89.72,0,0,0-32.08-8.33,41.47,41.47,0,0,0,4.77,29.16c24.48,43.42,91.07-2.4,91.07-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M501.52,968.92l22.6-76.55a2.27,2.27,0,0,1,2-1.6c4.1-.47,16-1.77,29.67-2.89,16.5-1.36,35.67-2.45,47.12-1.52a2.23,2.23,0,0,1,1.89,3.22c-6.51,12.78-33.3,64.75-46.72,81.78a2.35,2.35,0,0,1-1.86.89l-52.45-.47A2.26,2.26,0,0,1,501.52,968.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M558.08,881.24l16.39-2.65a1.16,1.16,0,0,1,1.31,1.49l-1.62,4.76a1.18,1.18,0,0,1-1,.78l-15.77,2a1.16,1.16,0,0,1-1.31-1.39l1-4.16A1.17,1.17,0,0,1,558.08,881.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M545.81,894.7l1.35-6.82a1.6,1.6,0,0,1,1.43-1.27l33.11-3.26a1.59,1.59,0,0,1,1.74,1.93l-2.1,8.5a1.63,1.63,0,0,1-1.5,1.21l-32.35,1.58A1.59,1.59,0,0,1,545.81,894.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M507,950.43s-3.15-12.56-1.88-17,3.73-10.19,11.93-8.91a122.56,122.56,0,0,1,17.88,4.62s-.48,5.8-6.72,3.93l3.87,2.9s-.56,4.65-5.82,2.17l3.59,3.84s-2.26,3.82-6.13,1.37S518,951.94,507,950.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M502.17,827.08l-12.56,35.24a1.25,1.25,0,0,0,.59,1.53c3.43,1.84,15.77,7.15,30.65-2a6,6,0,0,0,2.83-4.27l4.07-30.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M529.52,794.45s13.8,25.19,12,35.36-18.87,9.45-33.81,1.18L497.31,803.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M508.4,817.64a1,1,0,0,0,.47-1.52,26.62,26.62,0,0,1-3.84-7.91s-2.48-1.54,6.32-3.58,21.91-5.21,24.66-12.47c2.69-7.07-4.37-24.87-15.64-10.69a1.08,1.08,0,0,1-1.69,0c-1.85-2.33-6.71-7.17-13.45-4.23-6.31,2.74-7,7.22-6.93,9.48a1.06,1.06,0,0,1-1.26,1.06c-3.19-.59-10.85-1.1-14.42,6.52-2.94,6.27-1,9.82.71,11.55a1,1,0,0,1-.46,1.72c-2.09.62-4.8,2.35-4.53,7.11.38,6.58,8,6,10.13,5.7a1.09,1.09,0,0,1,.95.33c1.85,2,10.2,10.43,19.24,11.45a1.05,1.05,0,0,0,1.13-1.38l-3.91-11a1,1,0,0,1,.58-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M510,819.2s-9.83-6.53-10.55-1,8.85,8,13.59,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1796.35,377.66l-614.55-3c-7.4-.07-13.42,8.13-13.36,18.2l1.36,243.15c.06,10.13,6.23,18.22,13.68,17.92l611-13.09c7.1-.29,12.78-8.15,12.87-17.83l2.14-227.1C1809.63,385.93,1803.71,377.72,1796.35,377.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1183.08,638.09a2,2,0,0,1-1.73-2.17L1180,392.78a2.44,2.44,0,0,1,.46-1.49,1.54,1.54,0,0,1,1.28-.7l614.55,3a1.54,1.54,0,0,1,1.27.71,2.5,2.5,0,0,1,.45,1.49l-2.14,227.1a2,2,0,0,1-1.68,2.15h0Zm-1.36-246.5a.54.54,0,0,0-.47.29,1.46,1.46,0,0,0-.27.9l1.37,243.14c0,.69.38,1.17.72,1.17L1794.14,624c.33,0,.7-.49.71-1.16l2.14-227.1a1.47,1.47,0,0,0-.26-.9.56.56,0,0,0-.47-.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1206.72,
    y: 503.3,
    width: 29.91,
    height: 114.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 1256.69,
    y: 542.57,
    width: 29.91,
    height: 75.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1306.67,
    y: 445.5,
    width: 29.91,
    height: 172.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 1356.64,
    y: 576.24,
    width: 29.91,
    height: 41.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1406.61,
    y: 468.51,
    width: 29.91,
    height: 149.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 1456.58,
    y: 494.32,
    width: 29.91,
    height: 123.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1506.55,
    y: 522.37,
    width: 29.91,
    height: 95.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 1556.52,
    y: 410.71,
    width: 29.91,
    height: 206.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 1606.49,
    y: 432.59,
    width: 29.91,
    height: 184.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1656.46,
    y: 465.7,
    width: 29.91,
    height: 151.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 1706.44,
    y: 580.08,
    width: 29.91,
    height: 37.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1756.41,
    y: 507.22,
    width: 29.91,
    height: 110.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1047.21,308c-5.88-22.54-22.12-59.1-66.07-64.57-58.41-7.26-511.63-11.61-593.08-12.34a14.64,14.64,0,0,0-14.6,12.45c-3,19.81-7.79,59.48-4.16,92.73a14.67,14.67,0,0,0,15.09,13.11l649.19-23A14.67,14.67,0,0,0,1047.21,308Zm-32.92-1.95L403.68,327.67A14.12,14.12,0,0,1,389,313.83a389.24,389.24,0,0,1,2.59-47.2,16.1,16.1,0,0,1,16.16-14.32c241,2.25,527.84,6.66,570.77,12,21.88,2.71,34.57,16.44,41.93,31.48A7.16,7.16,0,0,1,1014.29,306.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M403.78,229.69c0,29.53.51,101.14,3.77,138.55a13.32,13.32,0,0,0,13.36,12.14c34.18-.2,132.41-1.35,178.4-7.71a13.3,13.3,0,0,0,11.34-11.57c3.13-25.2,10.16-92.25,1.76-128.29A13.39,13.39,0,0,0,600,222.41c-31.26-1.45-133.07-6-182.9-6.08A13.32,13.32,0,0,0,403.78,229.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M445.46,240.33l3.27,103.54a14.18,14.18,0,0,0,14.53,13.72l88.79-2.31a14.17,14.17,0,0,0,13.8-14.16V244.57a14.16,14.16,0,0,0-13.44-14.15l-92.07-4.69A14.17,14.17,0,0,0,445.46,240.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 966.33,
    y: 298.36,
    width: 8.41,
    height: 256.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 890.46,
    y: 421.13,
    width: 259.1,
    height: 8.41,
    transform: "translate(591.2 1443.89) rotate(-89.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 995.61,
    cy: 560.55,
    r: 30.09,
    transform: "translate(221.31 1400.74) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 995.61,
    cy: 560.55,
    r: 17.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M975,670l-10.3-56.19a19.14,19.14,0,0,1,18.82-22.59h25.59a22.27,22.27,0,0,1,22.2,24l-4.5,57.81a26.81,26.81,0,0,1-10.61,19.23c-9.31,7.06-22.46,21.73-25.32,49.3-4.53,43.66,36.47,58.31,61.7,53.62,19.68-3.67,30.39-27.43,26.16-45.21a10.42,10.42,0,0,1,10-13h0a10.35,10.35,0,0,1,10,7.83c5,19.72,11.35,70.56-50.31,80.55-73,11.83-143.84-66-81.43-128.93A29.84,29.84,0,0,0,975,670Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 995.61,
    cy: 293.96,
    r: 30.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 993.74,
    cy: 293.96,
    rx: 16,
    ry: 17.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1510.67,309,1407,320a21.71,21.71,0,0,1-24-21.59V178.76a21.72,21.72,0,0,1,18.61-21.49l103.63-14.92a21.71,21.71,0,0,1,24.8,21.49V287.45A21.71,21.71,0,0,1,1510.67,309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1426.84,286.79a15.36,15.36,0,1,1,15.36-15.36A15.38,15.38,0,0,1,1426.84,286.79Zm0-24.63a9.27,9.27,0,1,0,9.27,9.27A9.28,9.28,0,0,0,1426.84,262.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M1426.84,238.65a32.82,32.82,0,0,1,32.78,32.78,30.36,30.36,0,0,1-.18,3.32,2.23,2.23,0,0,0,2.54,2.47l4.77-.71a2.25,2.25,0,0,0,1.9-2.07c.07-1,.11-2,.11-3a41.92,41.92,0,0,0-47.09-41.6,2.24,2.24,0,0,0-1.94,2.6l.79,4.64a2.22,2.22,0,0,0,2.46,1.83A30.77,30.77,0,0,1,1426.84,238.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M1426.84,215a56.48,56.48,0,0,1,56.41,56.41v0a2.21,2.21,0,0,0,2.53,2.21l4.68-.7,1.93-2.23a65.51,65.51,0,0,0-74.78-64.2,2.23,2.23,0,0,0-1.85,2.58l.79,4.62a2.21,2.21,0,0,0,2.48,1.84A55.87,55.87,0,0,1,1426.84,215Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1426.84,191.39a80.13,80.13,0,0,1,80,76.62,2.23,2.23,0,0,0,2.55,2.14l4.64-.69a2.23,2.23,0,0,0,1.91-2.3,89.27,89.27,0,0,0-89.05-84.91,88.26,88.26,0,0,0-13.19,1,2.22,2.22,0,0,0-1.85,2.58l.79,4.62a2.22,2.22,0,0,0,2.54,1.82A79.41,79.41,0,0,1,1426.84,191.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1625.71,108.66l5-.18a1,1,0,0,1,.07,2h0l-5,.18h0a1,1,0,0,1-.07-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1635.72,108.35l5-.1a1,1,0,1,1,0,2h0l-5,.11h0a1,1,0,1,1,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1645.72,108.18l5-.05a1,1,0,0,1,1,1,1,1,0,0,1-1,1l-5,0a1,1,0,0,1,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1655.73,108.1h5a1,1,0,0,1,0,2h-5a1,1,0,0,1,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1665.73,108.12l5,0a1,1,0,0,1,1,1,1,1,0,0,1-1,1l-5,0a1,1,0,0,1,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1675.73,108.21l5,.08a1,1,0,1,1,0,2l-5-.07a1,1,0,0,1,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1685.73,108.39l5,.12a1,1,0,0,1,0,2l-5-.12a1,1,0,0,1,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1695.73,108.65l5,.16a1,1,0,0,1-.07,2l-5-.15a1,1,0,0,1,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1705.73,109l5,.19a1,1,0,0,1,.94,1,1,1,0,0,1-1,.94l-5-.19a1,1,0,1,1,.07-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1715.72,109.4l5,.24a1,1,0,1,1-.1,2l-5-.23a1,1,0,1,1,.09-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1725.71,109.89l5,.28a1,1,0,0,1-.11,2l-5-.27a1,1,0,0,1,.1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1735.7,110.47l5,.31a1,1,0,0,1-.12,2l-5-.32a1,1,0,1,1,.12-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1745.68,111.12l5,.36a1,1,0,0,1,.91,1,1,1,0,0,1-1,.91l-5-.36a1,1,0,0,1,.13-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1755.66,111.85l5,.4a1,1,0,0,1-.16,2l-5-.4a1,1,0,0,1,.14-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1765.63,112.67l5,.45a1,1,0,0,1,.89,1,1,1,0,0,1-1.06.89l-5-.44a1,1,0,1,1,.17-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1775.6,113.58l5,.49a1,1,0,1,1-.2,1.93l-5-.48a1,1,0,1,1,.18-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1785.55,114.57l5,.53a1,1,0,0,1,.87,1.07,1,1,0,0,1-1.08.86l-5-.52a1,1,0,1,1,.2-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1795.5,115.66l5,.58a1,1,0,1,1-.23,1.92l-5-.57a1,1,0,1,1,.21-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1805.43,116.84l5,.62a1,1,0,1,1-.25,1.92l-5-.62a1,1,0,1,1,.23-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1815.36,118.12l5,.67a1,1,0,1,1-.26,1.91l-5-.67a1,1,0,0,1-.84-1.08,1,1,0,0,1,1.09-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1825.28,119.49l5,.73a1,1,0,0,1-.28,1.91h0l-4.94-.73h0a1,1,0,0,1-.82-1.09,1,1,0,0,1,1.1-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1835.18,121l4.94.78a1,1,0,1,1-.3,1.9h0l-4.93-.78h0a1,1,0,1,1,.3-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1845.06,122.57l4.93.84a1,1,0,1,1-.32,1.89h0l-4.93-.83h0a1,1,0,0,1,.32-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1854.92,124.28l4.93.89a1,1,0,0,1,.77,1.12,1,1,0,0,1-1.12.77h0l-4.91-.89h0a1,1,0,1,1,.34-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1864.77,126.1l4.91,1a1,1,0,0,1,.76,1.12,1,1,0,0,1-1.13.76h0l-4.9-1h0a1,1,0,0,1-.76-1.12,1,1,0,0,1,1.13-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1874.59,128.05l4.9,1a1,1,0,0,1,.74,1.14,1,1,0,0,1-1.13.74h0l-4.89-1h0a1,1,0,1,1,.39-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1884.38,130.13l4.89,1.09a1,1,0,0,1,.72,1.14.94.94,0,0,1-1.14.72h0L1884,132h0a1,1,0,0,1-.73-1.13,1,1,0,0,1,1.14-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1894.15,132.35l4.87,1.16a1,1,0,0,1,.7,1.15.94.94,0,0,1-1.14.7h0l-4.86-1.16h0a1,1,0,1,1,.44-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1903.88,134.71l4.85,1.24a.95.95,0,1,1-.47,1.84h0l-4.84-1.23h0a.94.94,0,0,1-.69-1.15,1,1,0,0,1,1.16-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1913.57,137.23l4.84,1.31a.95.95,0,0,1-.5,1.83h0l-4.82-1.31h0a.95.95,0,1,1,.49-1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1923.23,139.9l4.81,1.4a.95.95,0,0,1-.53,1.82h0l-4.79-1.4h0a1,1,0,0,1-.65-1.17,1,1,0,0,1,1.18-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1932.83,142.75l4.79,1.49a.94.94,0,1,1-.57,1.8h0l-4.77-1.49h0a.94.94,0,0,1,.56-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1942.38,145.77l4.76,1.58a1,1,0,0,1,.59,1.2.93.93,0,0,1-1.19.59h0l-4.73-1.57h0a.94.94,0,1,1,.59-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1951.87,149l4.72,1.68a.94.94,0,0,1-.63,1.78h0l-4.7-1.67h0a.94.94,0,1,1,.63-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1961.29,152.41l4.68,1.79a.94.94,0,1,1-.67,1.75h0l-4.66-1.78h0a1,1,0,0,1-.54-1.22.93.93,0,0,1,1.21-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1970.63,156l4.64,1.91a.94.94,0,1,1-.71,1.73h0l-4.62-1.89h0a.93.93,0,0,1-.51-1.22.94.94,0,0,1,1.22-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1979.88,159.91l4.59,2a.94.94,0,1,1-.76,1.71h0l-4.56-2h0a.94.94,0,0,1,.75-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1989,164l4.52,2.15a.93.93,0,1,1-.8,1.69h0l-4.51-2.15h0A.94.94,0,1,1,1989,164Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1998.05,168.41l4.46,2.29a.93.93,0,0,1,.4,1.26,1,1,0,0,1-1.26.4h0l-4.43-2.28h0a.93.93,0,0,1,.86-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2006.93,173.07l4.38,2.44a.93.93,0,0,1-.9,1.63h0L2006,174.7h0a.92.92,0,0,1-.36-1.26.93.93,0,0,1,1.27-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2015.65,178l4.29,2.6a.93.93,0,0,1,.32,1.27.94.94,0,0,1-1.28.32h0l-4.26-2.58h0a.94.94,0,0,1-.32-1.28.93.93,0,0,1,1.28-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2024.18,183.31l4.21,2.72a.93.93,0,0,1-1,1.55h0l-4.19-2.71h0a.93.93,0,1,1,1-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2032.57,188.78l4.16,2.79a.93.93,0,0,1,.25,1.29.92.92,0,0,1-1.28.25h0l-4.15-2.79h0a.93.93,0,1,1,1-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2040.86,194.4l4.11,2.87a.93.93,0,0,1,.22,1.29.92.92,0,0,1-1.28.23h0l-4.09-2.85h0a.93.93,0,0,1,1.06-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2049,200.19l4.05,2.95a.92.92,0,0,1-1.09,1.49h0l-4-2.94h0a.92.92,0,1,1,1.09-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2057.1,206.14l4,3a.92.92,0,0,1-1.12,1.46h0l-4-3h0a.92.92,0,1,1,1.12-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2065,212.27l3.91,3.13a.92.92,0,0,1-1.15,1.44h0l-3.89-3.12h0a.92.92,0,1,1,1.15-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2072.81,218.59l3.82,3.24a.92.92,0,0,1-1.18,1.4h0l-3.81-3.22h0a.92.92,0,1,1,1.19-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2080.41,225.12l3.73,3.35a.92.92,0,0,1-1.22,1.37h0l-3.71-3.33h0a.92.92,0,0,1,1.22-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2087.82,231.88l3.63,3.47a.92.92,0,1,1-1.27,1.32h0l-3.6-3.45h0a.91.91,0,1,1,1.26-1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2095,238.88l3.5,3.59a.91.91,0,0,1-1.31,1.27h0l-3.48-3.57h0a.91.91,0,1,1,1.31-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2101.94,246.13l3.36,3.73a.91.91,0,1,1-1.35,1.22h0l-3.33-3.7v0a.91.91,0,0,1,1.35-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2108.58,253.67l3.2,3.88a.91.91,0,0,1-1.41,1.15h0l-3.17-3.85h0a.91.91,0,1,1,1.4-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2114.88,261.5l3,4a.91.91,0,0,1-1.46,1.08v0l-3-4v0a.91.91,0,0,1,1.46-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2120.77,269.65l2.77,4.19a.92.92,0,0,1-.26,1.26.9.9,0,0,1-1.25-.26l0,0-2.74-4.15v0a.9.9,0,0,1,.25-1.26.92.92,0,0,1,1.26.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2126.18,278.12l2.51,4.36a.9.9,0,0,1-.33,1.23.91.91,0,0,1-1.24-.33v0l-2.48-4.3v0a.9.9,0,0,1,1.56-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2131.05,286.92l2.2,4.53a.91.91,0,1,1-1.63.79v0l-2.17-4.47,0,0a.91.91,0,0,1,1.63-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2135.27,296.06l1.84,4.68a.9.9,0,1,1-1.68.66v0l-1.81-4.62,0,0a.9.9,0,0,1,1.68-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2138.75,305.51l1.42,4.83a.9.9,0,1,1-1.72.51v0l-1.41-4.75v0a.9.9,0,1,1,1.73-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2141.38,315.24l1,4.94a.9.9,0,1,1-1.76.35v0l-.95-4.87v0a.9.9,0,1,1,1.76-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2143.07,325.17l.47,5a.89.89,0,1,1-1.78.17v-.05l-.46-4.92v-.05a.88.88,0,0,1,.8-1,.89.89,0,0,1,1,.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2143.75,335.23l-.05,5a.9.9,0,0,1-1.79,0v-.05l.05-4.95v-.05a.9.9,0,0,1,1.79,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2143.38,345.31l-.58,5a.9.9,0,0,1-1,.79.89.89,0,0,1-.78-1v-.05l.56-4.92v0a.89.89,0,1,1,1.77.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2142,355.3l-1.09,4.92a.89.89,0,1,1-1.73-.38v0l1.06-4.84v0a.89.89,0,0,1,1.74.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2139.56,365.09l-1.55,4.79a.89.89,0,0,1-1.12.58.9.9,0,0,1-.57-1.12v0l1.53-4.72v0a.89.89,0,0,1,1.69.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2136.25,374.6l-2,4.63a.89.89,0,1,1-1.63-.69v0l1.94-4.57v0a.89.89,0,0,1,1.64.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2132.12,383.78l-2.33,4.45a.89.89,0,1,1-1.57-.82l0,0,2.3-4.39v0a.89.89,0,1,1,1.57.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2127.29,392.6l-2.65,4.27a.88.88,0,1,1-1.5-.93l0,0,2.61-4.22,0,0a.88.88,0,1,1,1.5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2121.85,401.06l-2.92,4.09a.88.88,0,0,1-1.23.2.89.89,0,0,1-.2-1.23v0l2.89-4.05,0,0a.87.87,0,0,1,1.22-.2.88.88,0,0,1,.21,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2115.9,409.15l-3.15,3.92a.9.9,0,0,1-1.24.13.88.88,0,0,1-.13-1.24h0l3.12-3.88v0a.88.88,0,1,1,1.38,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2109.5,416.89l-3.34,3.75a.88.88,0,0,1-1.31-1.17h0l3.31-3.72v0a.88.88,0,1,1,1.31,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2102.74,424.31l-3.51,3.59a.88.88,0,0,1-1.25-1.23h0l3.48-3.56v0a.88.88,0,0,1,1.24,0,.87.87,0,0,1,0,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2095.65,431.41l-3.64,3.45a.88.88,0,0,1-1.24,0,.87.87,0,0,1,0-1.23v0l3.62-3.42h0a.87.87,0,0,1,1.24,0,.86.86,0,0,1,0,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2088.3,438.23l-3.77,3.31a.88.88,0,0,1-1.23-.08.87.87,0,0,1,.08-1.23h0l3.74-3.29h0a.87.87,0,0,1,1.15,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2080.71,444.78l-3.87,3.18a.87.87,0,1,1-1.11-1.34h0l3.85-3.17h0a.87.87,0,0,1,1.11,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2072.91,451.08l-3.92,3.1a.86.86,0,0,1-1.22-.14.87.87,0,0,1,.14-1.22l3.93-3.1a.87.87,0,0,1,1.08,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2065.09,457.29l-3.89,3.14h0a.87.87,0,0,1-1.22-.13.86.86,0,0,1,.13-1.22l3.89-3.15a.87.87,0,1,1,1.09,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2057.33,463.59l-3.84,3.19h0a.86.86,0,0,1-1.21-.12.85.85,0,0,1,.11-1.21l3.85-3.2a.87.87,0,1,1,1.11,1.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2049.67,470l-3.79,3.25h0a.87.87,0,0,1-1.22-.09.86.86,0,0,1,.1-1.22l3.8-3.26a.86.86,0,0,1,1.22.1.85.85,0,0,1-.1,1.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2042.11,476.53l-3.73,3.31h0a.86.86,0,1,1-1.14-1.28l3.74-3.33a.87.87,0,0,1,1.22.07.88.88,0,0,1-.07,1.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2034.68,483.19l-3.67,3.39h0a.87.87,0,0,1-1.22,0,.85.85,0,0,1,0-1.21l3.67-3.41a.87.87,0,0,1,1.22.05.86.86,0,0,1,0,1.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2027.4,490l-3.58,3.48h0a.87.87,0,0,1-1.22,0,.85.85,0,0,1,0-1.21l3.58-3.5a.86.86,0,1,1,1.2,1.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2020.3,497l-3.46,3.59h0a.86.86,0,0,1-1.21,0,.85.85,0,0,1,0-1.21l3.48-3.62a.86.86,0,0,1,1.23,1.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2013.45,504.27l-3.32,3.72h0a.85.85,0,1,1-1.27-1.13l3.34-3.75a.85.85,0,1,1,1.27,1.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2006.9,511.78l-3.13,3.87,0,0a.85.85,0,1,1-1.32-1.08l3.16-3.9a.85.85,0,1,1,1.33,1.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2000.75,519.6l-2.89,4,0,0a.85.85,0,0,1-1.39-1l2.93-4.09a.85.85,0,1,1,1.38,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1995.11,527.79l-2.56,4.25,0,0a.85.85,0,0,1-1.46-.88l2.61-4.31a.86.86,0,0,1,1.17-.29.85.85,0,0,1,.28,1.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1990.18,536.39l-2.13,4.48,0,0a.85.85,0,0,1-1.13.4.84.84,0,0,1-.4-1.13l2.17-4.56a.85.85,0,1,1,1.53.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1986.18,545.45l-1.57,4.68,0,.06a.85.85,0,0,1-1.61-.54l1.61-4.79a.84.84,0,1,1,1.6.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1983.37,554.91l-.89,4.86v.06a.84.84,0,0,1-1.66-.3l.91-5a.84.84,0,1,1,1.66.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1982,564.67l-.13,4.94v.06a.84.84,0,0,1-1.68,0l.13-5.06a.85.85,0,0,1,1.69,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1982.08,574.54l.58,4.91v0a.84.84,0,0,1-.73.94.86.86,0,0,1-.94-.74l-.59-5a.84.84,0,0,1,.74-.93.83.83,0,0,1,.93.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1983.55,584.32l1.16,4.81v0a.84.84,0,1,1-1.63.4l-1.19-4.9a.84.84,0,0,1,1.64-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1986.11,593.89l1.6,4.71v0a.84.84,0,1,1-1.59.54l-1.62-4.76a.84.84,0,0,1,1.59-.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1989.47,603.24l1.89,4.6v0a.83.83,0,0,1-1.54.64l-1.92-4.64a.84.84,0,0,1,1.55-.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1993.37,612.4l2.08,4.53h0a.84.84,0,0,1-.41,1.11.83.83,0,0,1-1.1-.41l-2.11-4.55a.84.84,0,1,1,1.52-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1997.61,621.43l2.2,4.48h0a.83.83,0,1,1-1.49.74l-2.21-4.49a.85.85,0,0,1,.38-1.12.83.83,0,0,1,1.11.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2002.05,630.37l2.26,4.45a.83.83,0,1,1-1.48.76l-2.26-4.46a.83.83,0,1,1,1.48-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2006.55,639.32l2,4.6a.83.83,0,1,1-1.51.67v0l-2-4.53v0a.83.83,0,0,1,1.52-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2010.44,648.6l1.69,4.73a.83.83,0,0,1-1.56.55v0l-1.67-4.68v0a.81.81,0,0,1,.5-1,.83.83,0,0,1,1.06.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2013.67,658.11l1.4,4.81a.82.82,0,1,1-1.58.47v0l-1.39-4.77v0a.83.83,0,1,1,1.59-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2016.34,667.78l1.15,4.89a.83.83,0,1,1-1.61.37v0l-1.14-4.84v0a.82.82,0,0,1,1.6-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2018.51,677.58l.9,4.93a.82.82,0,1,1-1.61.3v0l-.89-4.9v0a.82.82,0,0,1,.66-1,.81.81,0,0,1,1,.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2020.2,687.47l.67,5a.82.82,0,1,1-1.62.22v0l-.66-4.94h0a.83.83,0,0,1,.71-.93.82.82,0,0,1,.92.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2021.43,697.42l.44,5a.82.82,0,0,1-1.63.14v0l-.44-5h0a.82.82,0,0,1,1.64-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2022.2,707.42l.21,5a.82.82,0,1,1-1.63.07v0l-.22-5v0a.82.82,0,0,1,.78-.85A.82.82,0,0,1,2022.2,707.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2022.51,717.45v5a.82.82,0,1,1-1.63,0v-5a.82.82,0,1,1,1.63,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2022.37,727.48l-.24,5a.82.82,0,0,1-1.63-.08v0l.23-5v0a.82.82,0,0,1,1.63.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2021.77,737.49l-.47,5a.81.81,0,0,1-.88.73.8.8,0,0,1-.73-.88v0l.46-5v0a.81.81,0,1,1,1.61.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2020.71,747.47l-.7,5a.81.81,0,1,1-1.6-.22v0l.7-4.93v0a.81.81,0,1,1,1.61.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2019.2,757.38l-.93,4.93a.81.81,0,0,1-1.59-.3v0l.93-4.89v0a.79.79,0,0,1,.94-.64.81.81,0,0,1,.65.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2017.22,767.21l-1.16,4.88a.81.81,0,0,1-1.57-.37v0l1.15-4.84v0a.81.81,0,1,1,1.57.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2014.78,776.94l-1.39,4.82a.8.8,0,0,1-1.54-.44v0l1.38-4.78v0a.8.8,0,0,1,1.54.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2011.89,786.55l-1.62,4.75a.8.8,0,0,1-1.52-.52v0l1.6-4.71v0a.8.8,0,1,1,1.52.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2008.54,796l-1.83,4.66a.8.8,0,1,1-1.49-.58v0l1.83-4.63v0a.8.8,0,0,1,1.49.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2004.76,805.3l-2.06,4.57a.79.79,0,0,1-1.06.4.79.79,0,0,1-.4-1v0l2-4.54v0a.8.8,0,1,1,1.46.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2000.54,814.4l-2.27,4.48a.8.8,0,0,1-1.07.35.81.81,0,0,1-.35-1.08h0l2.25-4.44v0a.81.81,0,0,1,1.08-.35.8.8,0,0,1,.35,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1995.9,823.3l-2.47,4.36a.79.79,0,0,1-1.38-.78v0l2.45-4.33v0a.8.8,0,1,1,1.38.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1990.86,832l-2.66,4.25a.8.8,0,0,1-1.1.25.79.79,0,0,1-.25-1.09v0l2.65-4.22h0a.79.79,0,1,1,1.34.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1985.44,840.41l-2.85,4.12a.79.79,0,0,1-1.3-.9h0l2.83-4.1h0a.78.78,0,0,1,1.1-.21.8.8,0,0,1,.2,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1979.66,848.59l-3,4a.8.8,0,0,1-1.11.16.8.8,0,0,1-.15-1.11h0l3-4h0a.79.79,0,0,1,1.27,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1973.52,856.53l-3.19,3.86a.78.78,0,0,1-1.11.11.79.79,0,0,1-.1-1.11h0l3.16-3.85h0a.79.79,0,1,1,1.21,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1967.07,864.2l-3.35,3.73a.78.78,0,0,1-1.11.06.79.79,0,0,1-.06-1.11h0l3.32-3.71h0a.79.79,0,0,1,1.12-.07.8.8,0,0,1,.06,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1960.31,871.6l-3.49,3.6a.79.79,0,0,1-1.13-1.09h0l3.47-3.58h0a.79.79,0,1,1,1.13,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1953.26,878.74l-3.62,3.46a.78.78,0,0,1-1.1,0,.79.79,0,0,1,0-1.11h0l3.6-3.44v0a.8.8,0,0,1,1.11,0,.78.78,0,0,1,0,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1946,885.61l-3.74,3.33a.79.79,0,0,1-1.11-.06.8.8,0,0,1,.07-1.11h0l3.72-3.31h0a.78.78,0,0,1,1.1.06.79.79,0,0,1-.06,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1938.42,892.21l-3.86,3.2a.78.78,0,1,1-1-1.2h0l3.83-3.19h0a.78.78,0,0,1,1.1.1.79.79,0,0,1-.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1930.66,898.54l-4,3.07a.78.78,0,0,1-1.09-.14.77.77,0,0,1,.13-1.09h0l3.94-3h0a.78.78,0,0,1,1.09.14.77.77,0,0,1-.13,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1922.69,904.62l-4,2.94a.78.78,0,1,1-.92-1.26h0l4-2.93h0a.77.77,0,0,1,1.08.17.78.78,0,0,1-.17,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1914.54,910.44l-4.14,2.82a.78.78,0,0,1-.88-1.28h0l4.13-2.81h0a.78.78,0,1,1,.88,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1906.21,916l-4.22,2.7a.76.76,0,0,1-1.06-.23.77.77,0,0,1,.23-1.07h0l4.2-2.68h0a.78.78,0,0,1,1.07.24.76.76,0,0,1-.24,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1897.73,921.35l-4.29,2.58a.78.78,0,0,1-1.06-.26.77.77,0,0,1,.27-1.06h0l4.27-2.57h0a.78.78,0,0,1,1.06.26.77.77,0,0,1-.27,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1889.11,926.45l-4.36,2.47a.77.77,0,0,1-1-.29.78.78,0,0,1,.3-1h0l4.35-2.46h0a.77.77,0,0,1,.76,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1880.36,931.33l-4.41,2.36a.77.77,0,0,1-.73-1.36h0l4.4-2.35h0a.77.77,0,0,1,1,.31.76.76,0,0,1-.32,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1871.5,936l-4.47,2.25a.77.77,0,0,1-1-.34.77.77,0,0,1,.34-1h0l4.45-2.24h0a.77.77,0,1,1,.69,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1862.53,940.43l-4.52,2.15a.76.76,0,0,1-.66-1.38h0l4.51-2.14h0a.76.76,0,0,1,.66,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1853.46,944.68l-4.57,2.05a.77.77,0,0,1-1-.39.75.75,0,0,1,.39-1h0l4.55-2h0a.74.74,0,0,1,1,.38.75.75,0,0,1-.38,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1844.3,948.73l-4.61,1.95a.76.76,0,1,1-.59-1.4h0l4.6-1.95h0a.76.76,0,0,1,.59,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1835.06,952.59l-4.65,1.86a.74.74,0,0,1-1-.42.76.76,0,0,1,.42-1h0l4.63-1.86h0a.74.74,0,0,1,1,.42.76.76,0,0,1-.42,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1825.75,956.27l-4.68,1.77a.76.76,0,0,1-1-.44.77.77,0,0,1,.44-1h0l4.66-1.77h0a.76.76,0,1,1,.54,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1816.37,959.77l-4.71,1.69a.75.75,0,0,1-.51-1.42h0l4.7-1.69h0a.75.75,0,1,1,.51,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1806.94,963.11l-4.75,1.61a.75.75,0,0,1-.48-1.43h0l4.72-1.61h0a.76.76,0,1,1,.49,1.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1604.03 67.05 1610.16 103.61 1582.76 92.05 1604.03 67.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1436.1,73.66l113.27,70a9.37,9.37,0,0,0,13.09-3.35l66-116.37a3.76,3.76,0,0,0-4.32-5.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1604.02 67.06 1436.1 73.66 1593.42 85.87 1595.55 95.94 1604.02 67.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1587.05 96.98 1610.16 103.61 1593.42 85.87 1587.05 96.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1734.92,1358.73a4.24,4.24,0,0,0,4.24-4.23V848.4a4.24,4.24,0,0,0-8.47,0v506.1A4.24,4.24,0,0,0,1734.92,1358.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1849.66,1358.73a4.24,4.24,0,0,0,4.24-4.23V848.4a4.24,4.24,0,0,0-8.47,0v506.1A4.24,4.24,0,0,0,1849.66,1358.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2131.57,1361.94a4.24,4.24,0,0,0,3.89-5.89L1918.94,846.74a4.23,4.23,0,1,0-7.79,3.32l216.52,509.3A4.23,4.23,0,0,0,2131.57,1361.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1997.83,1361.94a4.24,4.24,0,0,0,3.89-5.89L1785.2,846.74a4.23,4.23,0,1,0-7.79,3.32l216.52,509.3A4.23,4.23,0,0,0,1997.83,1361.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1728.35,853.06h198.34a6,6,0,0,0,6-6h0a6,6,0,0,0-6-6H1728.35a6,6,0,0,0-6,6h0A6,6,0,0,0,1728.35,853.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1814,930.51h134.13a4.24,4.24,0,1,0,0-8.47H1814a4.24,4.24,0,1,0,0,8.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1855.18,
    y: 1018.37,
    width: 134.14,
    height: 8.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1895.02,
    y: 1114.69,
    width: 134.14,
    height: 8.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1936.8,1219.48h134.14a4.24,4.24,0,1,0,0-8.47H1936.8a4.24,4.24,0,0,0,0,8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1977.2,1315.8h134.14a4.24,4.24,0,0,0,0-8.47H1977.2a4.24,4.24,0,0,0,0,8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M1752.38,836.48c8.23.71,22.51,1.86,33.77,2.36,6.76.3,10.66-.37,12.9-1.26,0,.25,0,.49,0,.71a2.33,2.33,0,0,1-2.21,2.2,393.49,393.49,0,0,1-44.21,0,1.65,1.65,0,0,1-1.35-2.49A13.25,13.25,0,0,1,1752.38,836.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1786.15,838.84c-11.26-.5-25.54-1.65-33.77-2.36,8.09-9.93,33.77-16.62,33.77-16.62h7.25a30.43,30.43,0,0,1,5.65,17.72C1796.81,838.47,1792.91,839.14,1786.15,838.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1794.62,808l-.68,13.42a3.06,3.06,0,0,1-2.62,2.89,12,12,0,0,1-5.45-.45,3.65,3.65,0,0,1-2.44-2.79L1781.09,808Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1888.8,838.74c3.57-.5,5.19-2.35,5.86-4.33l0,.05c.52,2.09-.69,4.26-3.13,5.29a20.51,20.51,0,0,1-8.65,1.35,8.61,8.61,0,0,1-6.49-3l0,0C1879.08,839.41,1882.85,839.57,1888.8,838.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1872,807.94h6c9.11-.19,14.83,19,16.7,26.47-.67,2-2.29,3.83-5.86,4.33-6,.83-9.72.67-12.41-.66-4.92-6.47-7.36-16-8.53-21.49A7.55,7.55,0,0,1,1872,807.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1877.19,795.48l3.32,13.2a3.58,3.58,0,0,1-1.86,4.07,12.75,12.75,0,0,1-6.88,1.66,3,3,0,0,1-2.44-2l-4.88-13.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1881.16,799.29c-4.14,3.67-17.57,4.15-17.57,4.15-48.41-116.18-68.21-132.68-68.21-132.68,7,43.85,1.12,140.93,1.12,140.93-8,3.52-18.28,0-18.28,0a748.66,748.66,0,0,0-24.72-183.76c32.72-.74,50.11-11.93,55.8-16.42C1836.57,655.47,1881.16,799.29,1881.16,799.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M1801,477.9c6.19,30.89,4,86.17,2.51,111.39-.41,7.09,4.54,16.91,8.54,23.62a2.09,2.09,0,0,1-.85,3c-6.7,3.44-29.38,14.11-55.67,15.44a3.75,3.75,0,0,1-3.77-2.8c-19.5-72.82-42.15-119.35-42.15-119.35C1734.61,469.22,1801,477.9,1801,477.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1792.07,668a1.58,1.58,0,0,0,.81-.23,1.56,1.56,0,0,0,.52-2.13A48.56,48.56,0,0,0,1774.2,649a1.55,1.55,0,1,0-1.34,2.79,46.44,46.44,0,0,1,17.89,15.48A1.55,1.55,0,0,0,1792.07,668Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1839.83,566.55c-2,14.39-7.87,30.08-19.62,46.76l-4.47-3.65A137.84,137.84,0,0,0,1818,565C1825.22,563.56,1833.78,565,1839.83,566.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M1794.07,516,1801,477.9s46.21,35.32,38.84,88.65c-6-1.53-14.61-3-21.87-1.57C1815.85,547.86,1809.54,529.29,1794.07,516Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M1709.6,509.15l17.84,38.42c-2.89,23.2-15.35,33.23-28.78,37.07a81.64,81.64,0,0,0-6-25C1709.83,541.9,1709.6,509.15,1709.6,509.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1692.67,559.62a81.64,81.64,0,0,1,6,25c-35.84,13.91-45.33-13.06-45.33-13.06l6.63-1.17C1674.92,572,1685.37,567.16,1692.67,559.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1726,461.72l8.62,31.66a6.15,6.15,0,0,0,8.23,4.1,125.33,125.33,0,0,0,12.42-5.67,8.3,8.3,0,0,0,2.92-11.93l-17.9-26.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1636.91,550.39l220.67,80.32a16.9,16.9,0,0,1,9.6,22.87l-.67,1.47a15.7,15.7,0,0,1-20.89,7.76l-214.27-99.13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-93",
    cx: 1535.48,
    cy: 502.08,
    rx: 108.93,
    ry: 106.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1414.26,502.08c0,65.74,54.27,119,121.22,119s121.21-53.29,121.21-119-54.27-119-121.21-119S1414.26,436.34,1414.26,502.08Zm17.81,0c0-56.08,46.29-101.54,103.41-101.54s103.4,45.46,103.4,101.54-46.29,101.54-103.4,101.54S1432.07,558.16,1432.07,502.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1647.47,516.51h-.06a.5.5,0,0,1-.43-.56c.35-2.78.6-5.62.74-8.43a.49.49,0,0,1,.53-.48.5.5,0,0,1,.47.52c-.14,2.85-.39,5.71-.75,8.52A.5.5,0,0,1,1647.47,516.51Zm-.83-33.28a.49.49,0,0,1-.49-.41,108.6,108.6,0,0,0-6.46-22.11h0c-17.27-41.89-58.18-69-104.21-69A113.58,113.58,0,0,0,1475.12,409a.49.49,0,0,1-.69-.16.51.51,0,0,1,.16-.69,114.57,114.57,0,0,1,60.89-17.39c46.44,0,87.71,27.31,105.13,69.58h0a108.66,108.66,0,0,1,6.52,22.31.5.5,0,0,1-.4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M1817.58,609l-20.86-1.7-9,8.33s2.14,3,8.82,1.25a95.36,95.36,0,0,1,15.84-2.11s9.23,4.16,9.34-3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1656,576.51c-1.8,1.41-8-1.53-11.77-3.56a4.37,4.37,0,0,1-2.1-5.15c.91-2.87,2.43-6.57,4.29-7C1649.52,560,1663.42,570.7,1656,576.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1853.22,659.41a.5.5,0,0,1-.16-1c6.36-2.2,9.69-5.77,9.9-10.63a11.8,11.8,0,0,0-7.72-11.37l-26.5-10.33a.51.51,0,0,1-.28-.65.5.5,0,0,1,.65-.28l26.49,10.33a12.79,12.79,0,0,1,8.36,12.34c-.23,5.31-3.79,9.19-10.57,11.54A.51.51,0,0,1,1853.22,659.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1820.76,623a.39.39,0,0,1-.18,0l-3.43-1.34a.5.5,0,0,1-.29-.64.5.5,0,0,1,.65-.29l3.43,1.34a.5.5,0,0,1-.18,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1724.17,430.65s-7.12,16.37-7.6,25-2.33,14.18,7.6,15.91,18.31-3.22,22.85-11.78c0,0,7.1-13.2,5.51-18.6S1724.17,430.65,1724.17,430.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1743.62,453.58h-1.25s5.17-10.62.62-12.48-22.56-5.54-26.45-11.93c-3.74-6.17-.4-14.13,4.6-16.35a.65.65,0,0,1,.85.31l.41.78a.68.68,0,0,0,1.25-.12h0a.67.67,0,0,1,1.21-.19c1.19,1.91,4.41,5,13.05,6.62,12.26,2.26,20.37,7.22,20.57,15.69a.67.67,0,0,0,1,.56c.91-.55,2.36-.81,4.29.82,3.37,2.83,2,10.17-5.39,16.21a.67.67,0,0,0,0,1.08c1.34.87,3.33,2.95-1.83,5.71s-8.42,2.52-9.6,2.21a.67.67,0,0,1-.51-.69l.46-7.51a.67.67,0,0,0-.67-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M1743.31,455.15s2.72-10.46,7.41-7.53-2.43,11.72-6.2,12.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1326.47,332.73H1260.3a9.16,9.16,0,0,1-9.16-9.16V257.22a9.15,9.15,0,0,1,8.42-9.13l70.5-5.71a9.16,9.16,0,0,1,9.89,9.68l-4.33,72.06A9.16,9.16,0,0,1,1326.47,332.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M1269.73,319.82a7,7,0,0,1-7-7V270.27a2.18,2.18,0,0,1,4.35,0v42.54a2.65,2.65,0,0,0,2.82,2.66l50.41-3a2.68,2.68,0,0,0,2.5-2.66V268a2.66,2.66,0,0,0-2.92-2.65l-41.94,4.16a2.66,2.66,0,0,0-1.89,4.21l16,22.07a2.63,2.63,0,0,0,2.14,1.1h0a2.62,2.62,0,0,0,2.13-1.06L1314,272.4a2.17,2.17,0,1,1,3.47,2.6l-17.61,23.48a6.83,6.83,0,0,1-5.67,2.8,6.94,6.94,0,0,1-5.61-2.9l-16-22.07a7,7,0,0,1,5-11.09l41.93-4.15a7,7,0,0,1,7.7,7v41.77a7,7,0,0,1-6.59,7l-50.41,3Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiImg1);
export default __webpack_public_path__ + "static/media/ui_img_1.dc97eb4dffb78e8b434ba13a370616da.svg";
export { ForwardRef as ReactComponent };